//  Copyright (c) 2007-2008 David Caldwell,  All Rights Reserved.

var dom = require('./dom'), doc=dom.doc, timeout=dom.timeout, cancel_timeout=dom.cancel_timeout, on_load=dom.on_load;
var lib = require('./lib'), merge=lib.merge, inherit=lib.inherit, rand=lib.rand;
var plat = require('./platform');
var score_game = require('./score_game');
var KeyboardFocusAutoPause = require('./keyfocus');
var prnt = require('./print'), sprintf=prnt.sprintf, printf=prnt.printf, print=prnt.print;
var geometry = require('./geometry'); var { point_scale, point_sum, polar_to_cartesian, point_difference, point_dot, point_cross, point_norm,
                                            point_squared_distance, point_distance, point_det, signed_distance_to_line, distance_to_line,
                                            distance_to_line_segment } = geometry;
var polygon = require('./polygon'), split_polygon=polygon.split_polygon;
var debug = require('./debug'), try_report=debug.try_report;
var highscore = require('./highscore'), elapsed_digital=highscore.elapsed_digital, HighScoreIntervalViewer=highscore.HighScoreIntervalViewer, censor=highscore.censor;
var Login = require('./login');

let ms__sec = 1000/1;
let sec__ms = 1/1000;
let frame30__ms = 30/*fps*/ / ms__sec;
let ms__frame30 = ms__sec / 30/*fps*/;

class Asteroids extends KeyboardFocusAutoPause.mixin(score_game) {
    constructor(canvas_div, highscore_div, highscoretabs_div) {
        super();
        this.highscore = new HighScoreIntervalViewerBuffered("asteroids");
        this.init("asteroids", undefined, highscore_div, highscoretabs_div);
        this.div = { canvas: canvas_div };
        this.screen = this.div.canvas.getContext("2d");
        this.gameover = 1;

        this.init_keyboard_focus_auto_pause(this.div.canvas);

        this.register_key_events(function(event) {
            var keydown = event.type == "keydown";
            switch(event.key) { // Keys that should be recognized even during Game Over
                case "q":      this.input.previous   = keydown; this.kick_soft_pause(); return false;
                case "e":      this.input.next       = keydown; this.kick_soft_pause(); return false;
                case "f":      this.input.fps        = keydown; this.kick_soft_pause(); return false;
                case "p":
                case "escape": if (keydown) { this.key_pause = 1; this.pause(); }      return false;
            }
            if (this.gameover) {
                if (keydown && this.gameover > 600/*ms*/ && (event.key == "space" || event.key == "z"))
                    this.new_game();
                return true;
            }
            switch(event.key) { // Keys that are only acknowledged during a game
                case "i":
                case "up":     this.input.hyperspace = keydown; return false;
                case "k":
                case "down":   this.input.thrust     = keydown; return false;
                case "j":
                case "left":   this.input.left       = keydown; return false;
                case "l":
                case "right":  this.input.right      = keydown; return false;
                case "z":
                case "space":  this.input.fire       = keydown; return false;
            }
        }, "keydown", "keyup");
        this.actors = [];
        this.frame();
    }

    collide() {
        if (this.paused) return;
        let deferred = [];
        for (let actor1 of this.actors) {
            for (let actor2 of this.actors) {
                if (actor1.removed || actor2.removed ||
                    actor1.collision_class == undefined ||
                    actor2.collision_class == undefined ||
                    actor1.collision_class == actor2.collision_class)
                    continue;
                if (point_distance(actor1.position, actor2.position) < actor1.radius + actor2.radius) {
                    // Let actos defer certain actions that might change their state so that the other actor
                    // gets the current state and not the new state (otherwise calculations based on one
                    // anothers state might do weird things depending on ordering)
                    deferred.push(actor1.collide(actor2));
                    deferred.push(actor2.collide(actor1));
                }
            }
        }
        for (let d of deferred)
            if (d) d();
    }

    think(dt_ms) {
        for (let actor of this.actors) {
            if (!actor.removed)
                if (!this.paused)
                    actor.think(dt_ms);
                else if (actor.pause_think)
                    actor.pause_think(dt_ms);
        }
    }

    draw_collision(screen, actor) {
        if (actor.collision_class == undefined)
            return;

        screen.beginPath();
        screen.arc(actor.position.x, actor.position.y, actor.radius, 0, 2 * Math.PI);
        screen.strokeStyle = "cyan";
        screen.stroke();
    }

    draw() {
        this.screen.fillStyle = "black";
        this.screen.fillRect(0, 0, this.div.canvas.width, this.div.canvas.height);
        this.screen.globalAlpha = 1.0;

        // Draw backward so higher priority stuff like the score and the ship draw on top
        for (var a=this.actors.length-1; a >= 0; a--) {
            this.screen.save();
            this.actors[a].draw(this.screen);
            this.screen.restore();
            //this.draw_collision(this.screen, this.actors[a]);
        }
    }

    remove_actor(actor) {
        actor.removed = true;
    }

    cull() {
        this.actors = this.actors.filter(function(a) { var removed = a.removed != true; delete a.removed; return removed; });
    };

    new_game() {
        score_game.prototype.new_game.call(this);
        this.gameover = 0;
        this.actors = [];
        this.actors.push(this.game = new GameActor(this));
        this.input = {};
        this.input_focus();
    }

    end_game() {
        score_game.prototype.end_game.call(this);
        this.gameover = 1;
    }

    kick_soft_pause() {
        if (!this.paused) return; // We don't switch into pause mode here, we just kick off soft mode if we're in hard mode or just got paused.
        cancel_timeout(this.soft_pause_timeout);
        this.soft_pause_timeout = timeout(10*ms__sec, () => this.hard_pause());
        if (!this.timeout) // Kick off the frames if they aren't already running.
            this.frame();
    }
    hard_pause() {
        delete this.soft_pause_timeout;
        if (!this.window_blurred) // If our window is active then don't hard pause.
            return this.kick_soft_pause();
        window.cancelAnimationFrame(this.timeout);
        delete this.timeout;
        this.draw();
    }
    on_pause() {
        this.kick_soft_pause();
    }
    on_unpause() {
        delete this.last_timestamp_ms;
        if (this.soft_pause_timeout) {
            cancel_timeout(this.soft_pause_timeout);
            delete this.soft_pause_timeout;
        } else // otherwise we were hard paused and we need to start the timer back up
            this.frame();
    }

    frame(timestamp_ms) {
        timestamp_ms = timestamp_ms || performance.now();
        this.last_timestamp_ms = this.last_timestamp_ms || timestamp_ms - 1000/60;
        this.collide();
        this.think(timestamp_ms - this.last_timestamp_ms);
        this.cull();
        this.draw();
        this.last_timestamp_ms = timestamp_ms;
        this.timeout = window.requestAnimationFrame(this.frame.bind(this));
    }
}

class GameActor {
    constructor(game) {
        this.game = game;
        this.name = "game";
        this.lives = 3;
        this.score = function(points) { if (!this.game.gameover) this.game.score.inc(points); };
        this.level = 0;
        this.level_timer_ms = 0;
        this.ship_timer_ms = 0;
        this.saucer = null;
        this.ship = new ShipActor(this.game);
        this.highscores = new HighScoreActor(this.game);
        this.zoomy_life_ms = 0;
    }
    foreach_actor_named(name, f) {
        this.game.actors.forEach(function(a) {
            if (a.name == name)
                f(a);
        });
    }
    count(name) {
        var count = 0;
        this.foreach_actor_named(name, function(a) {
            count++;
        });
        return count;
    };
    toggle_fps() {
        if (this.fps) {
            this.game.remove_actor(this.fps);
            delete this.fps;
        } else
            this.game.actors.unshift(this.fps = new FPSActor(this.game));
    }
    show_highscores(show) {
        if (show && !this.highscores_visible && this.highscores.ready()) {
            this.game.actors.unshift(this.highscores);
            this.highscores.added();
            this.highscores_visible = true;
        }
        if (!show && this.highscores_visible) {
            this.game.remove_actor(this.highscores);
            this.highscores_visible = false;
        }
    }
    ship_safe() {
        var seconds = 1.5; // Must be safe for this long
        var safe = 1;
        this.foreach_actor_named("asteroid", a => {
            var seg = { p1: a.position, p2: point_sum(a.position, point_scale(seconds * ms__sec, a.velocity_px__ms)) };
            var d = distance_to_line_segment(this.ship.position, seg.p1, seg.p2);
            if (d <= this.ship.radius + a.radius)
                safe = 0;
        });
        return safe;
    };
    think(dt_ms) {
        if (!this.count("asteroid") && (this.level_timer_ms -= dt_ms)<=0) {
            this.level++;
            for (var i=0; i<this.level * 2; i++)
                this.game.actors.push(new AsteroidActor(this.game,
                                                        {x:0,y:0},
                                                        polar_to_cartesian({theta:random(0, Math.PI*2),
                                                                            r:random(1,6) * frame30__ms}),
                                                        random(-Math.PI/20, +Math.PI/20) * frame30__ms,
                                                        3));
            this.level_timer_ms = 2 * ms__sec;
        }
        if (!this.count("ufo")) {
            if (this.ufo_timer_ms == undefined)
                this.ufo_timer_ms = random(10*ms__sec, 30*ms__sec);
            else if ((this.ufo_timer_ms -= dt_ms) <= 0) {
                delete this.ufo_timer_ms;
                this.game.actors.push(new UFOActor(this.game,
                                                   random(0, 1) < (this.level-1)/5));
            }
        }
        if (!this.count("ship")) {
            this.ship.reset();
            if ((this.ship_timer_ms -= dt_ms) <= 0 && this.lives > 0 && this.ship_safe()) {
                this.lives--;
                this.game.actors.push(this.ship);
                this.ship_timer_ms = 2 * ms__sec;
            }
        }
        if (this.game.gameover)
            this.game.gameover += dt_ms;
        if (!this.game.gameover && !this.count("ship") && !this.lives && !this.count("bullet"))
            this.game.end_game();
        this.pause_think(dt_ms);
    }
    pause_think(dt_ms) {
        this.show_highscores(this.game.gameover && this.game.gameover > 1000 || this.game.paused);
        if (this.game.input.fps) {
            delete this.game.input.fps;
            this.toggle_fps();
        }
        this.zoomy_life_ms += dt_ms;
    }
    draw(screen) {
        /* maybe draw score here? ok */
        screen.save();
        screen.translate(10,10);
        screen.scale(30,60);
        screen.lineWidth = 1/60;
        screen.strokeStyle = "white";
        draw_string(screen, ['span', { className: "scroll" }, sprintf("%05d", this.game.score.get())],
                    { classes: { scroll: { _h_scroll_in: (i) => screen.translate(30 * Math.cos(Math.min(Math.Pi/2, -i/10+this.zoomy_life_ms*2*Math.PI/5000)), 0) } } });
        screen.restore();

        if (this.game.paused || this.game.gameover) {
            screen.save();
            screen.translate(this.game.div.canvas.width/2, this.highscores_visible ? 100 : this.game.div.canvas.height/2);
            screen.scale(30,60);
            screen.lineWidth = 1/60;
            screen.strokeStyle = "white";
            draw_string(screen, ['span', {className:"zoomy"}, this.game.paused ? "Paused…" : "Game Over"],
                        { justify:'center',
                          vcenter:!this.highscores_visible,
                          classes: {zoomy: { _zoomy:(i) => {
                              let zoom = Math.sin(i*2*Math.PI/10 + this.zoomy_life_ms*2*Math.PI/1500) / 3 + 1;
                              screen.translate(1/2,1/2)
                              screen.scale(zoom, zoom);
                              screen.translate(-1/2,-1/2)
                          } } } });
            screen.restore();
        }

        screen.translate(10,87);
        for (var i=0; i<this.lives; i++) {
            screen.save();
            screen.rotate(180 * Math.PI/180);
            this.ship.draw_ship(screen, 0);
            screen.restore();
            screen.translate(20,0);
        }
    }
}

class MovingObjectActor {
    constructor(velocity_px__ms, friction_30fps, spin_rad__ms) {
        this.velocity_px__ms = velocity_px__ms || {x:0,y:0};
        this.friction = friction_30fps;
        this.spin_rad__ms = (spin_rad__ms || 0);
    }

    impulse_add(vector) {
        this.velocity_px__ms = point_sum(this.velocity_px__ms, vector);
    }

    impulse(angle, force) {
        this.impulse_add(polar_to_cartesian({r:force, theta:angle}));
    }

    newtonian_collision(position, velocity, mass) {
        // https://en.wikipedia.org/wiki/Elastic_collision#Two-dimensional_collision_with_two_moving_objects
        this.velocity_px__ms = point_difference(this.velocity_px__ms,
                                                point_scale((2*mass/(this.mass + mass) *
                                                             point_dot(point_difference(this.velocity_px__ms, velocity),
                                                                         point_difference(this.position, position)) /
                                                             point_norm(point_difference(this.position, position))),
                                                            point_difference(this.position, position)));
    }

    move(dt_ms) {
        this.move_nowrap(dt_ms);
        this.wrap();
    }
    move_nowrap(dt_ms) {
        this.position = point_sum(this.position, point_scale(dt_ms, this.velocity_px__ms));
        this.velocity_px__ms = point_scale((1 - this.friction) ** (dt_ms * frame30__ms), this.velocity_px__ms);
        this.theta += this.spin_rad__ms * dt_ms;
    }
    wrap() {
        if (this.position.x > this.game.div.canvas.width)  this.position.x -= this.game.div.canvas.width;
        if (this.position.x < 0)                           this.position.x += this.game.div.canvas.width;
        if (this.position.y > this.game.div.canvas.height) this.position.y -= this.game.div.canvas.height;
        if (this.position.y < 0)                           this.position.y += this.game.div.canvas.height;
    }

    explode(debris_drawer) {
        for (var i=0; i<360; i += random(40, 60))
            this.game.actors.push(new DebrisActor(this.game, this.position,
                                                  point_sum(this.velocity_px__ms,
                                                            polar_to_cartesian({r: random(10/*px__frame30*/, 20) * frame30__ms,
                                                                                theta:i * Math.PI/180})),
                                                  10/*frames30*/ * ms__frame30,
                                                  { friction: .1 },
                                                  debris_drawer));
    }

    break_apart(polygons, setup) {
        for (let i=0; i<3; i++) {
            let out = [];
            let cut_line = (() => {
                let pt = polar_to_cartesian({ r:200, theta: random(0, 2*Math.PI) });
                let line = [pt, {x: -pt.x, y: -pt.y }]; // line through center of circle
                let offset = { x: random(-this.radius/2, this.radius/2),
                               y: random(-this.radius/2, this.radius/2), };
                return [point_sum(line[0], offset), point_sum(line[1], offset)];
            })();
            for (let p of polygons) {
                try_report(() => {
                    out = out.concat(split_polygon(p, cut_line));
                }, "asteroids polygon splitter");
            }
            polygons = out;
        }

        for (let p of polygons)
            this.game.actors.push(new DebrisActor(this.game, this.position,
                                                      point_sum(this.velocity_px__ms,
                                                                polar_to_cartesian({r: random(3, 6)/180,
                                                                                    theta:random(0, 360) * Math.PI/180})),
                                                      2 * ms__sec,
                                                      {
                                                          theta: this.theta,
                                                          spin_rad__ms: random(-3, 3) * Math.PI/180 / 100,
                                                          trail_length: 0,
                                                      },
                                                      (screen, life_percent) => this.broken_drawer(screen, life_percent, setup, p)));
    }

    broken_drawer(screen, life_percent, setup, chunk) {
        screen.save();
        if (setup) setup(screen, life_percent);
        this.fill_poly(screen, chunk, null, undefined);
        screen.restore();
    }

    explode_in_flames(options) {
        return this.game.actors[this.game.actors.push(new ExplodeInFlamesActor(this.game, this.position, options))-1];
    }

    random_jagged_circle(min_points, max_points, min_radius, max_radius) {
        var poly = [];
        var ave = { sum:0, num:0 };
        for (var i=0; i<360; i += random(360/max_points, 360/min_points)) {
            let r;
            let p = polar_to_cartesian({r:r=random(min_radius, max_radius), theta:i * Math.PI/180});
            poly.push([p.x, p.y]);
            ave.sum += r;
            ave.num ++;
        }
        return { polygon: poly, radius: ave.sum/ave.num };
    }

    fill_poly(screen, points, fill, stroke) {
        screen.beginPath();
        for (let p of points)
            if (p == points[0])
                screen.moveTo(p[0], p[1]);
        else
            screen.lineTo(p[0], p[1]);
        screen.closePath();
        if (fill != undefined)   screen.fillStyle = fill;
        if (stroke != undefined) screen.strokeStyle = stroke;
        screen.fill();
        screen.stroke();
    }

    fill_rect(screen, x, y, w, h, fill, stroke) {
        if (fill)   screen.fillStyle = fill;
        if (stroke) screen.strokeStyle = stroke;
        screen.fillRect(x-w/2, y-h/2, w, h);
    }

}

class ShipActor extends MovingObjectActor {
    constructor(game) {
        super({x:0,y:0}, .01);
        this.game = game;
        this.name = "ship";
        this.collision_class = "ship and bullets";
        this.reset();
        this.radius = 12;
        this.fire_limit_ms = 0;
    }
    reset() {
        this.position = { x: this.game.div.canvas.width/2,
                          y: this.game.div.canvas.height/2 };
        this.theta = -90 * Math.PI/180;
        this.velocity_px__ms = {x:0,y:0};
    }
    collide(other) {
        this.game.remove_actor(this);
        // Whatever hit us moves us
        this.mass = this.radius**2;
        let other_mass = other.radius**2;
        let other_velocity = other.velocity_px__ms;
        let other_position = other.position;
        return () => {
            this.newtonian_collision(other_position, other_velocity, other_mass);
            this.break_apart([this.ship_poly],
                             (screen, life_percent) => {
                                 screen.strokeStyle = this.ship_stroke(life_percent*3);
                                 screen.fillStyle = this.ship_fill(life_percent*3);
                             });
            let exp = this.explode_in_flames({linewidth: [ 20, 15 ],
                                              max_radius: 75,
                                              spin_rad__ms: 15 * Math.PI/180 * sec__ms,
                                              velocity_px__ms: this.velocity_px__ms,
                                              again_again: { after_ms: 250,
                                                             options: {
                                                                 linewidth: [ 13, 7 ],
                                                                 max_radius:60,
                                                                 spin_rad__ms: -15 * Math.PI/180 * sec__ms,
                                                                 position_offset: {x: random(10,20), y: random(20,50)},
                                                             }}});
        }
    }
    think(dt_ms) {
        if (this.game.input.left)  this.theta -= 2*Math.PI/30  * frame30__ms * dt_ms;
        if (this.game.input.right) this.theta += 2*Math.PI/30  * frame30__ms * dt_ms;
        if (this.game.input.thrust) this.impulse(this.theta, .2/*px__frame30__frame30*/ * frame30__ms**2 * dt_ms);
        if (this.fire_limit_ms > 0) this.fire_limit_ms -= dt_ms;
        if (this.game.input.fire && this.fire_limit_ms <= 0) {
            this.game.actors.push(new BulletActor(this.game,
                                                  // Start bullet right at the nose of the ship
                                                  // Technically it should be 40/2-8 (draw
                                                  // translates -8, draw_ship scales by .5 and
                                                  // puts the nose point at 40)
                                                  point_sum(this.position,
                                                            polar_to_cartesian({ theta:this.theta,
                                                                                 r: this.radius})),
                                                  point_sum(this.velocity_px__ms,
                                                            polar_to_cartesian({ theta:this.theta,
                                                                                 r: 8/*px__frame30*/ * frame30__ms}))));
            this.fire_limit_ms = 5/*frame30*/ * ms__frame30;
        }
        this.move(dt_ms);
    }
    draw(screen) {
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta-Math.PI/2);

        this.draw_ship(screen, this.game.input.thrust);
    }

    draw_ship(screen, thrust) {
        screen.save();
        // This scale & translate needs to match the 'map' in ship_poly.
        // We could hardcode the transform into constants here but then they wouldn't match the ones in ship_poly.
        screen.translate(0,-8);
        screen.scale(.5,.5);
        if (thrust) {
            screen.beginPath();
            screen.moveTo(-5,0);

            screen.lineTo(-6 + random(-1,1), random(-16, -6));
            screen.lineTo( 0 + random(-1,1), random(-16, -6));
            screen.lineTo(+6 + random(-1,1), random(-16, -6));

            screen.lineTo(5,0);
            screen.closePath();
            screen.strokeStyle = "orange";
            screen.lineWidth = 2;
            screen.stroke();
        }
        screen.restore();

        this.fill_poly(screen, this.ship_poly, this.ship_fill(), this.ship_stroke());
    }

    ship_stroke(alpha = 1) { return `hsla(120, 0%, 100%, ${Math.max(0, Math.min(alpha, 1))})` } // "white"
    ship_fill(alpha = 1)   { return `hsla(120, 100%, 25%, ${Math.max(0, Math.min(alpha, 1))})`} // "green"

    ship_poly = [
        [  0,  0],
        [ -8,  0],
        [-16,-10], // back leftmost point
        [  0, 40], // tip of the nose
        [ 16,-10], // back rightmost point
        [  8,  0],
    ].map(pt => [ pt[0]/2, pt[1]/2 - 8 ]);
}


class BulletActor extends MovingObjectActor {
    constructor(game, position, velocity_px__ms, collision_class, color) {
        super(velocity_px__ms, 0, Math.PI/8 * frame30__ms);
        this.game = game;
        this.name = "bullet";
        this.collision_class = collision_class || "ship and bullets";
        this.color = color || "yellow";
        this.position = position;
        this.theta = 0;
        this.life_ms = 2 * ms__sec; //60 * actual_fps__30_fps; // 2 seconds...
        this.radius = 4;
    }
    collide() {
        this.game.remove_actor(this);
        this.explode_in_flames({max_radius: 10, steps: 3, explode_time_ms: 100, hold_time_ms: -50, fade_time_ms: 100, lineWidth: [2, .3]}); // Very small flames (for bullet on bullet violence)
    }
    think(dt_ms) {
        if ((this.life_ms -= dt_ms) <= 0)
            this.game.remove_actor(this);
        this.move(dt_ms);
    }

    draw(screen) {
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta);

        screen.fillStyle = this.color;
        screen.fillRect(-2,-2,4,4);
    }
}
class AsteroidActor extends MovingObjectActor {
    constructor(game, position, velocity, spin, size) {
        super(velocity,0,spin);
        this.game = game;
        this.name = "asteroid";
        this.collision_class = "asteroids";
        this.position = position;
        this.theta = 0;
        this.size = size;
        let r = [0, 13, 33, 45][size];
        let asteroid = this.random_jagged_circle(14, 70, r/2, r);
        this.outline = asteroid.polygon;
        this.radius = asteroid.radius;
    }

    collide(other) {
        this.game.game.score(25*this.size);
        if (this.size > 1)
            for (var i=0; i<2; i++)
                this.game.actors.push(new AsteroidActor(this.game,
                                                        this.position,
                                                        point_sum(point_sum(this.velocity_px__ms, point_scale(other.radius / this.radius, other.velocity_px__ms)),
                                                                  polar_to_cartesian({theta:random(0, Math.PI*2),
                                                                                      r:random(.5,2) * frame30__ms})),
                                                        random(-Math.PI/20, +Math.PI/20) * frame30__ms,
                                                        this.size -1));

        this.game.remove_actor(this);
        var debris = this.random_jagged_circle(5, 15, 2.5, 5.5);
        this.explode((screen, life_percent) => {
            this.fill_poly(screen, debris.polygon,
                           sprintf("rgba(%d,%d,%d,%f)", 20,20,20,  Math.min(1, life_percent*3)),
                           sprintf("rgba(%d,%d,%d,%f)", 255,255,0, Math.min(1, life_percent*3))
                          );
        });
    }
    think (dt_ms) {
        this.move(dt_ms);
    }
    draw(screen) {
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta-Math.PI/2);

        this.fill_poly(screen, this.outline, "rgb(20,20,20)", "brown");
    }
}

class UFOActor extends MovingObjectActor {
    constructor(game, small) {
        super(0, 0, 0);
        this.game = game;
        this.name = "ufo";
        this.collision_class = "ufo";
        this.position = {x: 0, y: random(0, this.game.div.canvas.height)};
        this.speed = random(5, 10)/60;
        this.radius = small ? 10 : 20;
        this.theta = -90 * Math.PI/180;
        this.small = small;
        this.light_offset = 0;
        this.change_direction();
        this.fire();
    }

    change_direction() {
        this.move_straight_life_ms = random(500, 1000);
        this.velocity_px__ms = polar_to_cartesian({r: this.speed,
                                                   theta: this.velocity_px__ms.y >= 0 ? -1 : 1 * random(1/16*Math.PI, 3/16*Math.PI)});
    }

    fire() {
        if (this.hold_fire_ms != undefined) { // don't shoot immediately.
            let theta = random(0, 2*Math.PI);
            this.game.actors.push(new BulletActor(this.game,
                                                  point_sum(this.position,
                                                            polar_to_cartesian({ theta:theta,
                                                                                 r: this.radius})),
                                                  point_sum(this.velocity_px__ms,
                                                            polar_to_cartesian({ theta:theta,
                                                                                 r: 5/*px__frame30*/ * frame30__ms})),
                                                  "ufo", "red"));
        }
        this.hold_fire_ms = random(500, 1000);
    }

    collide(other) {
        this.game.game.score(this.small ? 350 : 200);
        this.game.remove_actor(this);

        // Whatever hit us moves us
        this.mass = this.radius ** 2;
        let other_mass = other.radius**2;
        let other_velocity = other.velocity_px__ms;
        let other_position = other.position;
        return () => {
            this.newtonian_collision(other_position, other_velocity, other_mass);
            this.break_apart([this.saucer_poly, this.cockpit_poly],
                             (screen, life_percent) => {
                                 screen.scale(...this.small ? [.5,.5] : [1,1]);
                                 screen.strokeStyle = this.ufo_stroke(life_percent*3);
                                 screen.fillStyle = this.saucer_fill(life_percent*3);
                             });
            this.explode_in_flames({velocity_px__ms: this.velocity_px__ms, max_radius: this.radius*3});
        }
    }

    think(dt_ms) {
        if ((this.move_straight_life_ms -= dt_ms) <= 0)
            this.change_direction();

        if ((this.hold_fire_ms -= dt_ms) <= 0)
            this.fire();

        this.move_nowrap(dt_ms);
        if (this.position.x > this.game.div.canvas.width) // Go away once we've made our way across the screen
            this.game.remove_actor(this);
        this.wrap(); // handle y wrap

        this.light_offset -= dt_ms/250; // Animate the lights on the side of the saucer
        if (this.light_offset < 0)
            this.light_offset += -Math.ceil(this.light_offset)+1;
    }

    draw(screen) {
        screen.save();
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta-Math.PI/2);
        screen.scale(...this.small ? [.5,.5] : [1,1]);
        this.draw_ufo(screen, this.light_offset);
        screen.restore();
    }

    draw_ufo(screen, light_offset) {
        screen.save();
        this.fill_poly(screen, this.saucer_poly, this.saucer_fill(), this.ufo_stroke());
        this.fill_poly(screen, this.cockpit_poly, this.cockpit_fill(), this.ufo_stroke());
        screen.fillStyle = "white";
        let lights = 7;
        let light_len = 38;
        let light_delta = light_len/(lights);
        screen.translate(-light_len/2+.5, -7+.5);
        for (let i=0; i<lights; i++) {
            let x = (i+light_offset)*light_delta;
            // alpha_ramp's math is hard for me to follow. Here are the ranges of each term:
            // x                        -> 0 .. L
            // x-L/2                    -> -L/2 .. L/2
            // abs(x-L/2)               -> L/2 .. 0 .. L/2
            // L/2-abs(x-L/2)           -> 0 .. L/2 .. 0
            // (L/2-abs(x-L/2))/(D*2.5) -> 0 .. 1 .. M .. 1 .. 0  (1 @ x == D*2.5, x == L-D*2.5) M==some arbitrary max
            let alpha_ramp = (light_len/2 - Math.abs(x-light_len/2))/(light_delta*2.5);

            this.fill_rect(screen, x, 0, 2, 2,
                           sprintf("rgba(255,255,255,%d%%)", Math.min(100, 20 + 80*alpha_ramp)),
                           undefined);
        }
        screen.restore();
    }

    saucer_poly = [[-12,  0],
                   [-20, -7], // left hip
                   [-12,-14],
                   [ 12,-14],
                   [ 20, -7], // right hip
                   [ 12,  0]];

    cockpit_poly = [[-12,  0],
                    [-12,  9],
                    [ -6, 16], // cabin top
                    [  6, 16],
                    [ 12,  9],
                    [ 12,  0]];

    ufo_stroke(alpha = 1)   { return `hsla(180, 100%, 50%, ${Math.max(0, Math.min(alpha, 1))})` } // "cyan"
    saucer_fill(alpha = 1)  { return `hsla(180, 10%, 10%, ${Math.max(0, Math.min(alpha, 1))})`}   // dark grey
    cockpit_fill(alpha = 1) { return `hsla(180, 10%, 4%, ${Math.max(0, Math.min(alpha, 1))})`}    // even darker grey
}

class DebrisActor extends MovingObjectActor {
    constructor(game, position, velocity_px__ms, life_ms, options, drawer) {
        super(velocity_px__ms, options.friction || 0, random(-Math.PI/8, +Math.PI/8) * frame30__ms);
        this.game = game;
        this.name = "debris";
        this.drawer = drawer;
        this.position = position;
        this.theta = 0;
        this.max_life_ms = this.life_ms = life_ms;
        this.trail_length = 5;
        Object.assign(this, options);

        this.trail = [];
    }
    think(dt_ms) {
        if ((this.life_ms -= dt_ms) <= 0)
            this.game.remove_actor(this);
        this.trail.push(this.position);
        if (this.trail.length > this.trail_length)
            this.trail.shift();
        this.move(dt_ms);
    }

    draw(screen) {
        for (var t in this.trail) {
            screen.fillStyle = sprintf("rgba(%d,%d,%d,%f)", 255,128,0, t/(this.trail_length/2) * (this.life_ms/this.max_life_ms));
            screen.fillRect(this.trail[t].x, this.trail[t].y, t*.5+2, t*.5+2);
        }
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta - Math.PI/2);

        this.drawer(screen, this.life_ms/this.max_life_ms);
    }
}

class ExplodeInFlamesActor extends MovingObjectActor {
    constructor(game, position, options) {
        super(0, 0, 0);
        this.game = game;
        this.position = position;
        this.theta = 0;

        this.explode_time_ms = 1000;
        this.hold_time_ms = -500;
        this.fade_time_ms = 1000;
        this.again_again = undefined;

        this.max_radius = 150;
        this.steps = 10;
        this.linewidth = [5, .2];

        Object.assign(this, options);
        this.options = options;

        if (this.position_offset)
            this.position = point_sum(this.position, this.position_offset);

        this.step_scale = this.max_radius / this.steps;
        this.life_ms = 0;
        this.max_life_ms = this.explode_time_ms + this.hold_time_ms + this.fade_time_ms;
        this.flame_poly = this.random_jagged_circle(15, 25, .5, 1).polygon;
    }

    think(dt_ms) {
        this.move(dt_ms);
        this.life_ms += dt_ms;

        if (this.again_again && this.life_ms > this.again_again.after_ms) {
            this.game.actors.push(new ExplodeInFlamesActor(this.game, this.position,
                                                           Object.assign({}, this.options, { again_again: undefined }, this.again_again.options)));
            delete this.again_again;
        }

        if (this.life_ms > this.max_life_ms)
            this.game.remove_actor(this);
    }

    draw(screen) {
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta - Math.PI/2);
        let expl_progress = Math.min(1, this.life_ms/this.explode_time_ms);
        let fade_progress = Math.max(0, this.life_ms - this.explode_time_ms - this.hold_time_ms)/this.fade_time_ms;
        for (let step=Math.floor(this.steps * fade_progress);
             step < this.steps * expl_progress;
             step++) {
            screen.save();

            let scale = ramp(this.step_scale/2, this.step_scale, this.max_life_ms, this.life_ms);
            screen.scale(scale * step, scale * step);
            screen.strokeStyle = `hsla(${ramp(0, 60, this.steps, step)}, 100%, ${ramp(80, 40, 2000, this.life_ms + step * 200)}%, ${ramp(1, 0, 1, fade_progress)})`;
            screen.lineWidth = ramp(this.linewidth[0], this.linewidth[1], this.steps, step)/(this.step_scale*step);
            screen.beginPath();
            for (let p of this.flame_poly)
                screen.lineTo(p[0], p[1]);
            screen.closePath();
            screen.stroke();

            screen.restore();
        }
    }
}

function ramp(from, to, total, cur) {
    return from + Math.max(0, Math.min(cur, total))*(to-from)/total;
}

class FPSActor {
    constructor(game) {
        this.game = game;
        this.name = "fps";

        this.frame_times = [];
    }

    think(dt_ms) {
        this.pause_think(dt_ms)
    }
    pause_think(dt_ms) {
        this.frame_times.push(dt_ms);
        if (this.frame_times.length > 60) this.frame_times.shift();
        this.fps = 1000 / (this.frame_times.reduce((sum, t) => sum + t) / this.frame_times.length);
    }

    draw(screen) {
        screen.save();
        screen.translate(this.game.div.canvas.width-10,10);
        screen.scale(5,10);
        screen.lineWidth = 1/5;
        screen.strokeStyle = '#888';
        draw_string(screen, sprintf("%d FPS", this.fps), {justify:'right'});
        screen.restore();
    }
}

class HighScoreActor {
    constructor(game) {
        this.game = game;
        this.score_buffer = this.game.highscore;
        this.life_ms = 0;
        this.scroll_in_life_ms = 0;
        this.timeframes = Object.keys(this.score_buffer.timeframe);
        this.timeframei = this.timeframes.findIndex(t => t == this.score_buffer.current_timeframe);
    }

    ready() {
        return !this.score_buffer.state.loading;
    }

    added() {
        this.scroll_in_life_ms = 0;
    }

    timeframe_step(step) {
        this.timeframei = (this.timeframei + step + this.timeframes.length /*keep it positive*/) % this.timeframes.length;
        this.score_buffer.switch_timeframe(this.timeframes[this.timeframei]);
    }

    think(dt_ms) {
        this.pause_think(dt_ms);
    }

    pause_think(dt_ms) {
        this.life_ms += dt_ms;

        if (this.game.input.next) {
            delete this.game.input.next;
            this.timeframe_step(+1);
        }
        if (this.game.input.previous) {
            delete this.game.input.previous;
            this.timeframe_step(-1);
        }
        if (this.score_buffer.state.loading)
            this.scroll_in_life_ms = 0; // so it always starts scrolling when it appears
        else
            this.scroll_in_life_ms += dt_ms;
    }

    draw(screen) {
        screen.save();
        try {
            screen.translate(this.game.div.canvas.width/2, 0);
            screen.strokeStyle = "white";
            let font_size = (px) => {
                screen.scale(1,2);
                let scale = this.game.div.canvas.height / px;
                screen.scale(px/2,px/2);
                screen.lineWidth = 1/(px/2);
            };
            let posessive = (timeframe) => timeframe == "All Time" ? timeframe : timeframe + "'s";
            screen.translate(0, 200);
            screen.save();
            font_size(30);
            draw_string(screen, ['span', { className: "jumpy" }, sprintf("←Q   %s High Scores   E→", posessive(this.score_buffer.state.timeframe)) ],
                        { justify:'center',
                          classes: {jumpy: { _jumpy:(i) => {
                              screen.translate(0, Math.sin(i*2*Math.PI/10 + this.life_ms*2*Math.PI/1000) / 4);
                          } } } });
            screen.restore();
            screen.translate(0, 40*1.5);
            font_size(20);
            let header;
            draw_string(screen, header=sprintf("%2s %-20.20s %6s %5s\n", "", "Name", "Score", "Time"), { justify:'center' });
            let chars = header.length;
            screen.translate(0, 1.2 + .2);

            screen.beginPath();
            screen.moveTo(-chars*1.5/2, 0);
            screen.lineTo( chars*1.5/2, 0);
            screen.stroke();

            screen.translate(0, .2 + .2);

            if (this.score_buffer.state.loading) {
                draw_string(screen, "Loading Scores…", { justify:'center' });
            } else if (this.score_buffer.state.error) {
                screen.strokeStyle = 'hsl(0, 100%, 30%)';
                draw_string(screen, `Err: ${this.score_buffer.state.error}`, { justify:'center' });
            } else {
                let place = 1;
                let score_text = ['span',
                                  this.score_buffer.state.scores.map((s,i) =>
                                      ['span',
                                       { classes: [].concat(s.user == Login.user ? [ 'myscore' ] : [],
                                                            (s.play_id == this.score_buffer.play_id) ? ['lastscore'] : []) },
                                       sprintf("%2s %-20.20s %6d ",
                                               i>0 && this.score_buffer.state.scores[i-1].score == s.score ? '' : place++,
                                               !s.banned || s.user == Login.user ? s.user : censor("".normalize ? s.user.normalize("NFD") : s.user),
                                               s.score),
                                       elapsed_digital(s.elapsed),
                                       "\n"])];

                draw_string(screen, score_text, { justify: 'center',
                                                  spacing: 1.4,
                                                  classes: { lastscore: { strokeStyle: (i) => hsl(ramp(0,360, chars, (-i + chars*this.life_ms/2500) % chars), 100, 50),
                                                                          _h_scroll_in: (i) => screen.translate(80 * Math.cos(Math.min(Math.PI/2, -i/50+this.scroll_in_life_ms*2*Math.PI/5000)), 0),
                                                                          _hop: (i) => screen.translate(0, -Math.max(0, Math.sin(-i*2*Math.PI/(chars*3) + this.life_ms*2*Math.PI/3000)*chars*3-(chars*3-1)) / 4),
                                                                        },
                                                             myscore: { lineWidth: 2/12,
                                                                        strokeStyle: (i,r,c) => hsl(ramp(0,360, chars, (-i-r + chars*this.life_ms/5000) % chars), 80, 70),
                                                                      },
                                                             zeros: { globalAlpha: .2}} });
            }
        } catch(e) { printf("Caught error: %s\n", e); }
        screen.restore();
    }
}

class HighScoreIntervalViewerBuffered extends HighScoreIntervalViewer {
    constructor(title) {
        super(title);
        this.state = { loading: false, scores: [], game_id: undefined, error: undefined };
        this.init();
    }

    update_timeframe_tabs(new_t) {
        this.state.timeframe = new_t;
    }

    loading() {
        this.state.error = undefined;
        this.state.scores = undefined;
        this.state.loading = true;
    }

    render(scores) {
        this.state.loading = false;
        this.state.scores = scores;
    }

    error(error) {
        this.state.loading = false;
        this.state.error = error;
    }
}


function clamp(v,min,max) { return Math.max(min, Math.min(v, max)) }
function hsl(hue, saturation, lightness, alpha=undefined) { return alpha == undefined ? sprintf("hsl(%d, %d%%, %d%%)", clamp(hue, 0, 360), clamp(saturation, 0,100), clamp(lightness, 0, 100))
                                                                                      : sprintf("hsla(%d, %d%%, %d%%, %.3f)", clamp(hue, 0, 360), clamp(saturation, 0, 100), clamp(lightness, 0, 100), clamp(alpha, 0, 1)); }

const r = String.raw;
var alpha_font =  [r` _   _   _  _   __  _  __     _ _  _ _                  _   _   _   _   __ _ _                        __ `,
                   r`/_\ |_> |  | \ |_  |_ | _ |_|  |    |  |/ |  |\/| |\ | | | |_| | | |_| |_   |  | | |  | |    | \/ \ /  / `,
                   r`| | |_> |_ |_/ |__ |  |_| | | _|_ |_|  |\ |_ |  | | \| |_| |   |_x | \ __|  |  |_|  \/   \/\/  /\  |  /_ `,
                   r`a   b   c  d   e   f  g   h   i   j    k  l  m    n    o   p   q   r   s   t   u   v    w      x  y   z  `];
var num_font = [r` _      __  __       __  __ ___  _   _  `,
                r`| | /|   _| __| |_| |_  |_    / |_| |_| `,
                r`|_| _|_ |__ __|   | __| |_|  |  |_|   | `,
                r`0   1   2   3   4   5   6   7   8   9   `];
var symbol_font = [r`                                                      `,
                   r`  -                                     _ _ \|/ /_ _\ `,
                   r`  -           _ _           _   _   _   /|\     \   / `,
                   r`:             _ .           …           *   *   ←  →  `];

var big_glyphs = [r` __  __                           ____  `,
                  r`/  \/  \              _/         /    \ `,
                  r`\      /                              | `,
                  r` \    /                              /  `,
                  r`  \  /                              |   `,
                  r`   \/     _/                        _   `,
                  r`♥        ,           '           ?      `];

function build_font(font) {
    let height = font.length-1;
    let maxy = height-1;
    var start = font[height].split(/[^ ]/);
    start.shift();
      var i=0;
    var char_slice = function(font, start, length) {
        return font.slice(0,height).map(line => line.slice(start, start+length));
    };
    let debug = new DebugFont(start.length);
    var lines = {};
    for (var s in start) {
        var l = start[s].length;
        var c = char_slice(font, i+0, l);
        var ch = font[height].charAt(i);
        let get = (x,y) => x < 0 || y < 0 || y > maxy ? undefined : c[y].charAt(x);
        lines[ch] ||= [];
        var xscale = 1/l;
        let yscale = 1/maxy;
        for (var y=0; y<height; y++)
            for (var x=0; x<l; x++) {
                let yy=y;
                let pipex = (x) => x + (x == 0 ? 0 : x == l-1 ? 1 : .5);
                switch (get(x,y)) {
                case '-': yy -= .5;
                case '_': {
                    let x1 = x, x2 = x+1;
                    if (get(x+1,y+1) == '|' ||
                        get(x+1,y)   == '|' ||
                        get(x+1,y)   == '\\') x2 = pipex(x+1); // →
                    if (get(x-1,y)   == '|' ||                // practically everything
                        get(x-1,y+1) == '|' ||                // B,C,D,E,F,G,I,J,O,P,Q,R,S,T,Z
                        get(x-1,y)   == '/') x1 = pipex(x-1); // Z
                    lines[ch].push({from:[x1*xscale, yy*yscale], to:[x2*xscale, yy*yscale]});
                }   break;
                case '|': {
                    let xx = pipex(x);
                    lines[ch].push({from:[(xx)*xscale, (y-1) * yscale], to:[(xx)*xscale, (y)*yscale]});
                }   break;
                case '/': {
                    let x1 = x, x2 = x+1;
                    if (get(x-1,y+1) == '|' ||                // Y,K
                        get(x-1,y)   == '|') x1 = pipex(x-1); // *
                    if (get(x+1,y-1) == '|' ||                // W,V
                        get(x+1,y)   == '|') x2 = pipex(x+1); // M
                    lines[ch].push({from:[x1*xscale, y*yscale], to:[x2*xscale, (y-1)*yscale]});
                }   break;
                case '\\': {
                    let x1 = x, x2 = x+1;
                    if (get(x-1,y-1) == '|' ||                // W,V
                        get(x-1,y)   == '|') x1 = pipex(x-1); // M,N
                    if (get(x+1,y+1) == '|' ||                // Y,K
                        get(x+1,y)   == '|') x2 = pipex(x+1); // N
                    lines[ch].push({from:[x1*xscale, (y-1)*yscale], to:[x2*xscale, y*yscale]});
                }   break;
                case '>': {                                   // B
                    let x1 = x, x2 = x+1;
                    let yt = y-1, ym = y-.5, yb = y;
                    lines[ch].push({from:[x1*xscale, yt*yscale], to:[x2*xscale, ym*yscale]});
                    lines[ch].push({from:[x2*xscale, ym*yscale], to:[x1*xscale, yb*yscale]});
                }   break;
                case 'x': {                                   // Q
                    let x1 = x, x2 = x+1;
                    let yt = y-1, yb = y;
                    lines[ch].push({from:[x1*xscale, yb*yscale], to:[x2*xscale, yt*yscale]});
                    lines[ch].push({from:[x1*xscale, yt*yscale], to:[x2*xscale, yb*yscale]}); // Q's tail
                }   break;
                }
            }

        debug.draw_char(0+s, ch, l, maxy, lines[ch]);

        i += l+1;
    }
    return lines;
}

class DebugFont {
    constructor(chars) {
        return undefined;
        let padding = .1;
        let c_w = Math.min(10, chars);
        let c_h = Math.ceil(chars / c_w);
        let size = { width: c_w, height:c_h };
        let zoom = 1000/c_w;
        let el = doc(["canvas", { style: { width: `${size.width*zoom}px`, height: `${size.height*zoom}px`} }]);
        el.width = size.width*zoom;
        el.height = size.height*zoom;
        print(doc(['span', el, ['br']]));
        let ctx = el.getContext("2d");
        ctx.fillStyle = "black";
        ctx.fillRect(0,0, el.width, el.height);
        ctx.scale(zoom, zoom);
        ctx.scale(c_w/(c_w+(c_w-1)*padding), c_h/(c_h+(c_h-1)*padding));
        ctx.translate(size.width/2, size.height/2);
        ctx.scale(.93, .93);
        ctx.translate(-size.width/2, -size.height/2);
        ctx.lineWidth = 2/zoom;
        Object.assign(this, { el: el, ctx: ctx, size:size, zoom:zoom, padding:padding });
    }

    draw_grid(ch, l, maxy) {
        let {ctx} = this;
        ctx.strokeStyle = "rgb(20,20,20)";
        for (let y=0; y<=maxy; y++) {
            ctx.beginPath();
            ctx.moveTo(0,y/maxy);
            ctx.lineTo(1,y/maxy);
            ctx.stroke();
        }
        ctx.strokeStyle = "rgb(20,20,20)";
        for (var x=0; x<=l; x++) {
            ctx.beginPath();
            ctx.moveTo(x/(l),0);
            ctx.lineTo(x/(l),1);
            ctx.stroke()
        }
        ctx.strokeStyle = "rgb(40,40,40)";
        ctx.beginPath();
        ctx.moveTo(0,0);
        ctx.lineTo(1,0);
        ctx.lineTo(1,1);
        ctx.lineTo(0,1);
        ctx.closePath();
        ctx.stroke();

        ctx.fillStyle = "rgb(150,150,150)";
        ctx.fillRect(0,0,.25,.25);
        ctx.font = `.25px serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = "black";
        ctx.fillText(ch, .25/2, .25/2+.07);
    }

    draw_char(s, ch, l, maxy, lines) {
        let {ctx, size, padding} = this;
        if (!ctx) return; // debugging not enabled
        ctx.save();
        let cy = Math.floor(s/size.width);
        let cx = s % size.width;
        ctx.translate(cx + (cx)*padding, cy + (cy) * padding);

        this.draw_grid(ch, l, maxy);

        ctx.strokeStyle = "#9ff";
        for (let line of lines) {
            ctx.beginPath();
            ctx.moveTo(line.from[0], line.from[1]);
            ctx.lineTo(line.to[0], line.to[1]);
            ctx.fillStyle = "pink";
            let pt_w=1/30, pt_h=1/30;
            ctx.fillRect(line.from[0] - pt_w/2, line.from[1] - pt_h/2, pt_w, pt_h);
            ctx.fillRect(line.to[0] - pt_w/2, line.to[1] -pt_h/2, pt_w, pt_h);
            ctx.stroke();
        }
        ctx.restore();
    }
}


var font;
on_load(function() {
    font = merge(build_font(alpha_font),
                 build_font(num_font),
                 build_font(symbol_font),
                 build_font(big_glyphs));
    font[' '] = []; // Special case space since my split wont find it. :-(
    font['\u00a0'] = []; // nbsp
});


// The idea here is that it returns an array of lines, just like the old draw_string had after it called
// split("\n") on the input. Along with that it returns a sparsely populated 2 dimensional hash where the
// [row][col] entries are a list of style directives to apply before drawing the character at that location.
//
// Each style directive is either a set of attributes to merge into the current style, or the string "pop" to
// go back to the old style (like an html </span> close tag). This code doesn't care about the specifics of
// the styles, except it separates classes from "inline" styles since it was easier to do here.
function richtext_to_lines(text) {
    class node {
        constructor(s, text) {
            this.lines = s.split("\n");
            this.my_style = { inline: {}, classes: undefined };
            this.styles = {};
            this.push_styles_at({row:0,col:0}, [this.my_style]);
        }
        end_pos() {
            let row = this.lines.length-1;
            let col = this.lines[row].length;
            return { row:row, col:col };
        }
        push_styles_at(pos, styles) {
            this.styles[pos.row] ||= {};
            this.styles[pos.row][pos.col] ||= [];
            this.styles[pos.row][pos.col].push(...styles);
        }
        append_lines(new_lines) {
            this.lines[this.end_pos().row] += new_lines.shift();
            this.lines = this.lines.concat(new_lines);
        }
        setAttribute(k,v) { if (k == "classes") this.my_style.classes = v;
                            else if (k == "className") this.my_style.classes = [v];
                            else this.my_style.inline[k] = v; }
        appendChild(child)  {
            let { row, col } = this.end_pos();
            let new_lines = child.lines;
            if (new_lines.length > 1 && new_lines[0] == "" && this.styles[row]) {     // Annoying special case. If the first new char is '\n' then
                this.push_styles_at({row:row+1, col:0}, this.styles[row][col] || []); // everything we had on the last line pointing a the "next"
                delete this.styles[row][col];                                         // character needs to move down first.
            }
            for (let [r, cols] of Object.entries(child.styles)) {
                for (let [c, styles] of Object.entries(cols)) {
                    let extra_col = r == 0 ? col : 0;
                    this.push_styles_at({row: Number(r)+row, col: Number(c)+extra_col}, styles);
                }
            }
            this.append_lines(new_lines);
            this.push_styles_at(this.end_pos(), ["pop"]);
        }
    }
    let asteroids_doc = {
        createElement: (_tag_name) => new node("", false),
        createTextNode: (s) => new node(s, true),
    };

    let out = doc(text, asteroids_doc);
    return { line: out.lines, styles: out.styles || {} };
}

function draw_string(screen, s, options={}) {
    screen.save();

    let class_def = options.classes || {};
    let { line, styles } = richtext_to_lines(s);

    var kerning = options.kerning || 1.5;
    var spacing = options.spacing || 1.2;

    if (options.vcenter)
        screen.translate(0, -line.length * spacing / 2);

    let style_stack = []; // We call this a stack but we use .shift() and .unshift() because style_stack[0] is easier than style_stack[style_stack.length-1]
    for (var li in line) {
        screen.save();
        if (options.justify == 'center')
            screen.translate(-line[li].length * kerning / 2, 0);
        if (options.justify == 'right')
            screen.translate(-line[li].length * kerning, 0);
        for (var si=0; si<line[li].length; si++) {
            var f = font[line[li].charAt(si).toLowerCase()] || font['?'];
            if (!f) {
                printf("No character for '%s' _or_ the backup character '?' [%#x]!\n", line[li].charAt(si), line[li].charCodeAt(si));
                continue;
            }
            if (styles[li] && styles[li][si]) {
                for (let s of styles[li][si])
                    if (s == "pop")
                        style_stack.shift();
                    else
                        style_stack.unshift(Object.fromEntries(
                            Object.entries(Object.assign({}, class_def.default||{}, style_stack[0]||{}, ...(s.classes||[]).map(c => class_def[c]), s.inline))
                                .map(([k, v], i) => [k, typeof(v) == 'function' ? {f:v, i:0} : v])));
            }
            screen.save(); // we save here so that we don't have to know the "default" versions of any styles we are about to set
            for (let [k,v] of Object.entries(style_stack[0]))
                if (typeof(v.f) == "function") screen[k] = v.f(v.i++, li-0, si);
                else screen[k] = v;
            for (var l = 0; l<f.length; l++) {
                screen.beginPath();
                screen.moveTo(f[l].from[0], f[l].from[1]);
                screen.lineTo(f[l].to  [0], f[l].to  [1]);
                screen.closePath();
                screen.stroke();
            }
            screen.restore();
            screen.translate(kerning, 0);
        }
        screen.restore();
        screen.translate(0,spacing);
    }
    screen.restore();
}

var the_game;
on_load(function() {
    window.the_game = the_game = new Asteroids(doc.id("playfield"),
                                               doc.id("global_high_score"),
                                               doc.id("scoretab"));
    the_game.new_game();

    doc.id("keybinding-toggle").onclick = (event) => {
        doc.id('keys').classList.toggle("hidden");
        return false;
    }
});

function rand_unit() {
    return rand() / 0x7fffffff;
}

function random(low, high) {
    return rand_unit() * (high - low) + low;
}

//  Copyright (c) 2007-2008 David Caldwell,  All Rights Reserved.

var dom = require('./dom'), doc=dom.doc, timeout=dom.timeout, cancel_timeout=dom.cancel_timeout, on_load=dom.on_load;
var lib = require('./lib'), merge=lib.merge, inherit=lib.inherit, rand=lib.rand;
var plat = require('./platform');
var score_game = require('./score_game');
var KeyboardFocusAutoPause = require('./keyfocus');
var prnt = require('./print'), sprintf=prnt.sprintf, printf=prnt.printf, print=prnt.print;
var geometry = require('./geometry'); var { point_scale, point_sum, polar_to_cartesian, point_difference, point_dot, point_cross, point_norm,
                                            point_squared_distance, point_distance, point_det, signed_distance_to_line, distance_to_line,
                                            distance_to_line_segment } = geometry;
var polygon = require('./polygon'), split_polygon=polygon.split_polygon;
var debug = require('./debug'), try_report=debug.try_report;
var highscore = require('./highscore'), elapsed_digital=highscore.elapsed_digital, HighScoreIntervalViewer=highscore.HighScoreIntervalViewer, censor=highscore.censor;
var Login = require('./login');

let ms__sec = 1000/1;
let sec__ms = 1/1000;
let frame30__ms = 30/*fps*/ / ms__sec;
let ms__frame30 = ms__sec / 30/*fps*/;

class Asteroids extends KeyboardFocusAutoPause.mixin(score_game) {
    constructor(canvas_div, highscore_div, highscoretabs_div) {
        super();
        this.highscore = new HighScoreIntervalViewerBuffered("asteroids");
        this.init("asteroids", undefined, highscore_div, highscoretabs_div);
        this.div = { canvas: canvas_div };
        this.screen = this.div.canvas.getContext("2d");
        this.gameover = 1;

        this.init_keyboard_focus_auto_pause(this.div.canvas);

        this.register_key_events(function(event) {
            var keydown = event.type == "keydown";
            switch(event.key) { // Keys that should be recognized even during Game Over
                case "q":      this.input.previous   = keydown; this.kick_soft_pause(); return false;
                case "e":      this.input.next       = keydown; this.kick_soft_pause(); return false;
                case "f":      this.input.fps        = keydown; this.kick_soft_pause(); return false;
                case "p":
                case "escape": if (keydown) { this.key_pause = 1; this.pause(); }      return false;
            }
            if (this.gameover) {
                if (keydown && this.gameover > 600/*ms*/ && (event.key == "space" || event.key == "z"))
                    this.new_game();
                return true;
            }
            switch(event.key) { // Keys that are only acknowledged during a game
                case "i":
                case "up":     this.input.hyperspace = keydown; return false;
                case "k":
                case "down":   this.input.thrust     = keydown; return false;
                case "j":
                case "left":   this.input.left       = keydown; return false;
                case "l":
                case "right":  this.input.right      = keydown; return false;
                case "z":
                case "space":  this.input.fire       = keydown; return false;
            }
        }, "keydown", "keyup");
        this.actors = [];
        this.frame();
    }

    collide() {
        if (this.paused) return;
        let deferred = [];
        for (let actor1 of this.actors) {
            for (let actor2 of this.actors) {
                if (actor1.removed || actor2.removed ||
                    actor1.collision_class == undefined ||
                    actor2.collision_class == undefined ||
                    actor1.collision_class == actor2.collision_class)
                    continue;
                if (point_distance(actor1.position, actor2.position) < actor1.radius + actor2.radius) {
                    // Let actos defer certain actions that might change their state so that the other actor
                    // gets the current state and not the new state (otherwise calculations based on one
                    // anothers state might do weird things depending on ordering)
                    deferred.push(actor1.collide(actor2));
                    deferred.push(actor2.collide(actor1));
                }
            }
        }
        for (let d of deferred)
            if (d) d();
    }

    think(dt_ms) {
        for (let actor of this.actors) {
            if (!actor.removed)
                if (!this.paused)
                    actor.think(dt_ms);
                else if (actor.pause_think)
                    actor.pause_think(dt_ms);
        }
    }

    draw_collision(screen, actor) {
        if (actor.collision_class == undefined)
            return;

        screen.beginPath();
        screen.arc(actor.position.x, actor.position.y, actor.radius, 0, 2 * Math.PI);
        screen.strokeStyle = "cyan";
        screen.stroke();
    }

    draw() {
        this.screen.fillStyle = "black";
        this.screen.fillRect(0, 0, this.div.canvas.width, this.div.canvas.height);
        this.screen.globalAlpha = 1.0;

        // Draw backward so higher priority stuff like the score and the ship draw on top
        for (var a=this.actors.length-1; a >= 0; a--) {
            this.screen.save();
            this.actors[a].draw(this.screen);
            this.screen.restore();
            //this.draw_collision(this.screen, this.actors[a]);
        }
    }

    remove_actor(actor) {
        actor.removed = true;
    }

    cull() {
        this.actors = this.actors.filter(function(a) { var removed = a.removed != true; delete a.removed; return removed; });
    };

    new_game() {
        score_game.prototype.new_game.call(this);
        this.gameover = 0;
        this.actors = [];
        this.actors.push(this.game = new GameActor(this));
        this.input = {};
        this.input_focus();
    }

    end_game() {
        score_game.prototype.end_game.call(this);
        this.gameover = 1;
    }

    kick_soft_pause() {
        if (!this.paused) return; // We don't switch into pause mode here, we just kick off soft mode if we're in hard mode or just got paused.
        cancel_timeout(this.soft_pause_timeout);
        this.soft_pause_timeout = timeout(10*ms__sec, () => this.hard_pause());
        if (!this.timeout) // Kick off the frames if they aren't already running.
            this.frame();
    }
    hard_pause() {
        delete this.soft_pause_timeout;
        if (!this.window_blurred) // If our window is active then don't hard pause.
            return this.kick_soft_pause();
        window.cancelAnimationFrame(this.timeout);
        delete this.timeout;
        this.draw();
    }
    on_pause() {
        this.kick_soft_pause();
    }
    on_unpause() {
        delete this.last_timestamp_ms;
        if (this.soft_pause_timeout) {
            cancel_timeout(this.soft_pause_timeout);
            delete this.soft_pause_timeout;
        } else // otherwise we were hard paused and we need to start the timer back up
            this.frame();
    }

    frame(timestamp_ms) {
        timestamp_ms = timestamp_ms || performance.now();
        this.last_timestamp_ms = this.last_timestamp_ms || timestamp_ms - 1000/60;
        this.collide();
        this.think(timestamp_ms - this.last_timestamp_ms);
        this.cull();
        this.draw();
        this.last_timestamp_ms = timestamp_ms;
        this.timeout = window.requestAnimationFrame(this.frame.bind(this));
    }
}

class GameActor {
    constructor(game) {
        this.game = game;
        this.name = "game";
        this.lives = 3;
        this.score = function(points) { if (!this.game.gameover) this.game.score.inc(points); };
        this.level = 0;
        this.level_timer_ms = 0;
        this.ship_timer_ms = 0;
        this.saucer = null;
        this.ship = new ShipActor(this.game);
        this.highscores = new HighScoreActor(this.game);
        this.zoomy_life_ms = 0;
    }
    foreach_actor_named(name, f) {
        this.game.actors.forEach(function(a) {
            if (a.name == name)
                f(a);
        });
    }
    count(name) {
        var count = 0;
        this.foreach_actor_named(name, function(a) {
            count++;
        });
        return count;
    };
    toggle_fps() {
        if (this.fps) {
            this.game.remove_actor(this.fps);
            delete this.fps;
        } else
            this.game.actors.unshift(this.fps = new FPSActor(this.game));
    }
    show_highscores(show) {
        if (show && !this.highscores_visible && this.highscores.ready()) {
            this.game.actors.unshift(this.highscores);
            this.highscores.added();
            this.highscores_visible = true;
        }
        if (!show && this.highscores_visible) {
            this.game.remove_actor(this.highscores);
            this.highscores_visible = false;
        }
    }
    ship_safe() {
        var seconds = 1.5; // Must be safe for this long
        var safe = 1;
        this.foreach_actor_named("asteroid", a => {
            var seg = { p1: a.position, p2: point_sum(a.position, point_scale(seconds * ms__sec, a.velocity_px__ms)) };
            var d = distance_to_line_segment(this.ship.position, seg.p1, seg.p2);
            if (d <= this.ship.radius + a.radius)
                safe = 0;
        });
        return safe;
    };
    think(dt_ms) {
        if (!this.count("asteroid") && (this.level_timer_ms -= dt_ms)<=0) {
            this.level++;
            for (var i=0; i<this.level * 2; i++)
                this.game.actors.push(new AsteroidActor(this.game,
                                                        {x:0,y:0},
                                                        polar_to_cartesian({theta:random(0, Math.PI*2),
                                                                            r:random(1,6) * frame30__ms}),
                                                        random(-Math.PI/20, +Math.PI/20) * frame30__ms,
                                                        3));
            this.level_timer_ms = 2 * ms__sec;
        }
        if (!this.count("ufo")) {
            if (this.ufo_timer_ms == undefined)
                this.ufo_timer_ms = random(10*ms__sec, 30*ms__sec);
            else if ((this.ufo_timer_ms -= dt_ms) <= 0) {
                delete this.ufo_timer_ms;
                this.game.actors.push(new UFOActor(this.game,
                                                   random(0, 1) < (this.level-1)/5));
            }
        }
        if (!this.count("ship")) {
            this.ship.reset();
            if ((this.ship_timer_ms -= dt_ms) <= 0 && this.lives > 0 && this.ship_safe()) {
                this.lives--;
                this.game.actors.push(this.ship);
                this.ship_timer_ms = 2 * ms__sec;
            }
        }
        if (this.game.gameover)
            this.game.gameover += dt_ms;
        if (!this.game.gameover && !this.count("ship") && !this.lives && !this.count("bullet"))
            this.game.end_game();
        this.pause_think(dt_ms);
    }
    pause_think(dt_ms) {
        this.show_highscores(this.game.gameover && this.game.gameover > 1000 || this.game.paused);
        if (this.game.input.fps) {
            delete this.game.input.fps;
            this.toggle_fps();
        }
        this.zoomy_life_ms += dt_ms;
    }
    draw(screen) {
        /* maybe draw score here? ok */
        screen.save();
        screen.translate(10,10);
        screen.scale(30,60);
        screen.lineWidth = 1/60;
        screen.strokeStyle = "white";
        draw_string(screen, ['span', { className: "scroll" }, sprintf("%05d", this.game.score.get())],
                    { classes: { scroll: { _h_scroll_in: (i) => screen.translate(30 * Math.cos(Math.min(Math.Pi/2, -i/10+this.zoomy_life_ms*2*Math.PI/5000)), 0) } } });
        screen.restore();

        if (this.game.paused || this.game.gameover) {
            screen.save();
            screen.translate(this.game.div.canvas.width/2, this.highscores_visible ? 100 : this.game.div.canvas.height/2);
            screen.scale(30,60);
            screen.lineWidth = 1/60;
            screen.strokeStyle = "white";
            draw_string(screen, ['span', {className:"zoomy"}, this.game.paused ? "Paused…" : "Game Over"],
                        { justify:'center',
                          vcenter:!this.highscores_visible,
                          classes: {zoomy: { _zoomy:(i) => {
                              let zoom = Math.sin(i*2*Math.PI/10 + this.zoomy_life_ms*2*Math.PI/1500) / 3 + 1;
                              screen.translate(1/2,1/2)
                              screen.scale(zoom, zoom);
                              screen.translate(-1/2,-1/2)
                          } } } });
            screen.restore();
        }

        screen.translate(10,87);
        for (var i=0; i<this.lives; i++) {
            screen.save();
            screen.rotate(180 * Math.PI/180);
            this.ship.draw_ship(screen, 0);
            screen.restore();
            screen.translate(20,0);
        }
    }
}

class MovingObjectActor {
    constructor(velocity_px__ms, friction_30fps, spin_rad__ms) {
        this.velocity_px__ms = velocity_px__ms || {x:0,y:0};
        this.friction = friction_30fps;
        this.spin_rad__ms = (spin_rad__ms || 0);
    }

    impulse_add(vector) {
        this.velocity_px__ms = point_sum(this.velocity_px__ms, vector);
    }

    impulse(angle, force) {
        this.impulse_add(polar_to_cartesian({r:force, theta:angle}));
    }

    newtonian_collision(position, velocity, mass) {
        // https://en.wikipedia.org/wiki/Elastic_collision#Two-dimensional_collision_with_two_moving_objects
        this.velocity_px__ms = point_difference(this.velocity_px__ms,
                                                point_scale((2*mass/(this.mass + mass) *
                                                             point_dot(point_difference(this.velocity_px__ms, velocity),
                                                                         point_difference(this.position, position)) /
                                                             point_norm(point_difference(this.position, position))),
                                                            point_difference(this.position, position)));
    }

    move(dt_ms) {
        this.move_nowrap(dt_ms);
        this.wrap();
    }
    move_nowrap(dt_ms) {
        this.position = point_sum(this.position, point_scale(dt_ms, this.velocity_px__ms));
        this.velocity_px__ms = point_scale((1 - this.friction) ** (dt_ms * frame30__ms), this.velocity_px__ms);
        this.theta += this.spin_rad__ms * dt_ms;
    }
    wrap() {
        if (this.position.x > this.game.div.canvas.width)  this.position.x -= this.game.div.canvas.width;
        if (this.position.x < 0)                           this.position.x += this.game.div.canvas.width;
        if (this.position.y > this.game.div.canvas.height) this.position.y -= this.game.div.canvas.height;
        if (this.position.y < 0)                           this.position.y += this.game.div.canvas.height;
    }

    explode(debris_drawer) {
        for (var i=0; i<360; i += random(40, 60))
            this.game.actors.push(new DebrisActor(this.game, this.position,
                                                  point_sum(this.velocity_px__ms,
                                                            polar_to_cartesian({r: random(10/*px__frame30*/, 20) * frame30__ms,
                                                                                theta:i * Math.PI/180})),
                                                  10/*frames30*/ * ms__frame30,
                                                  { friction: .1 },
                                                  debris_drawer));
    }

    break_apart(polygons, setup) {
        for (let i=0; i<3; i++) {
            let out = [];
            let cut_line = (() => {
                let pt = polar_to_cartesian({ r:200, theta: random(0, 2*Math.PI) });
                let line = [pt, {x: -pt.x, y: -pt.y }]; // line through center of circle
                let offset = { x: random(-this.radius/2, this.radius/2),
                               y: random(-this.radius/2, this.radius/2), };
                return [point_sum(line[0], offset), point_sum(line[1], offset)];
            })();
            for (let p of polygons) {
                try_report(() => {
                    out = out.concat(split_polygon(p, cut_line));
                }, "asteroids polygon splitter");
            }
            polygons = out;
        }

        for (let p of polygons)
            this.game.actors.push(new DebrisActor(this.game, this.position,
                                                      point_sum(this.velocity_px__ms,
                                                                polar_to_cartesian({r: random(3, 6)/180,
                                                                                    theta:random(0, 360) * Math.PI/180})),
                                                      2 * ms__sec,
                                                      {
                                                          theta: this.theta,
                                                          spin_rad__ms: random(-3, 3) * Math.PI/180 / 100,
                                                          trail_length: 0,
                                                      },
                                                      (screen, life_percent) => this.broken_drawer(screen, life_percent, setup, p)));
    }

    broken_drawer(screen, life_percent, setup, chunk) {
        screen.save();
        if (setup) setup(screen, life_percent);
        this.fill_poly(screen, chunk, null, undefined);
        screen.restore();
    }

    explode_in_flames(options) {
        return this.game.actors[this.game.actors.push(new ExplodeInFlamesActor(this.game, this.position, options))-1];
    }

    random_jagged_circle(min_points, max_points, min_radius, max_radius) {
        var poly = [];
        var ave = { sum:0, num:0 };
        for (var i=0; i<360; i += random(360/max_points, 360/min_points)) {
            let r;
            let p = polar_to_cartesian({r:r=random(min_radius, max_radius), theta:i * Math.PI/180});
            poly.push([p.x, p.y]);
            ave.sum += r;
            ave.num ++;
        }
        return { polygon: poly, radius: ave.sum/ave.num };
    }

    fill_poly(screen, points, fill, stroke) {
        screen.beginPath();
        for (let p of points)
            if (p == points[0])
                screen.moveTo(p[0], p[1]);
        else
            screen.lineTo(p[0], p[1]);
        screen.closePath();
        if (fill != undefined)   screen.fillStyle = fill;
        if (stroke != undefined) screen.strokeStyle = stroke;
        screen.fill();
        screen.stroke();
    }

    fill_rect(screen, x, y, w, h, fill, stroke) {
        if (fill)   screen.fillStyle = fill;
        if (stroke) screen.strokeStyle = stroke;
        screen.fillRect(x-w/2, y-h/2, w, h);
    }

}

class ShipActor extends MovingObjectActor {
    constructor(game) {
        super({x:0,y:0}, .01);
        this.game = game;
        this.name = "ship";
        this.collision_class = "ship and bullets";
        this.reset();
        this.radius = 12;
        this.fire_limit_ms = 0;
    }
    reset() {
        this.position = { x: this.game.div.canvas.width/2,
                          y: this.game.div.canvas.height/2 };
        this.theta = -90 * Math.PI/180;
        this.velocity_px__ms = {x:0,y:0};
    }
    collide(other) {
        this.game.remove_actor(this);
        // Whatever hit us moves us
        this.mass = this.radius**2;
        let other_mass = other.radius**2;
        let other_velocity = other.velocity_px__ms;
        let other_position = other.position;
        return () => {
            this.newtonian_collision(other_position, other_velocity, other_mass);
            this.break_apart([this.ship_poly],
                             (screen, life_percent) => {
                                 screen.strokeStyle = this.ship_stroke(life_percent*3);
                                 screen.fillStyle = this.ship_fill(life_percent*3);
                             });
            let exp = this.explode_in_flames({linewidth: [ 20, 15 ],
                                              max_radius: 75,
                                              spin_rad__ms: 15 * Math.PI/180 * sec__ms,
                                              velocity_px__ms: this.velocity_px__ms,
                                              again_again: { after_ms: 250,
                                                             options: {
                                                                 linewidth: [ 13, 7 ],
                                                                 max_radius:60,
                                                                 spin_rad__ms: -15 * Math.PI/180 * sec__ms,
                                                                 position_offset: {x: random(10,20), y: random(20,50)},
                                                             }}});
        }
    }
    think(dt_ms) {
        if (this.game.input.left)  this.theta -= 2*Math.PI/30  * frame30__ms * dt_ms;
        if (this.game.input.right) this.theta += 2*Math.PI/30  * frame30__ms * dt_ms;
        if (this.game.input.thrust) this.impulse(this.theta, .2/*px__frame30__frame30*/ * frame30__ms**2 * dt_ms);
        if (this.fire_limit_ms > 0) this.fire_limit_ms -= dt_ms;
        if (this.game.input.fire && this.fire_limit_ms <= 0) {
            this.game.actors.push(new BulletActor(this.game,
                                                  // Start bullet right at the nose of the ship
                                                  // Technically it should be 40/2-8 (draw
                                                  // translates -8, draw_ship scales by .5 and
                                                  // puts the nose point at 40)
                                                  point_sum(this.position,
                                                            polar_to_cartesian({ theta:this.theta,
                                                                                 r: this.radius})),
                                                  point_sum(this.velocity_px__ms,
                                                            polar_to_cartesian({ theta:this.theta,
                                                                                 r: 8/*px__frame30*/ * frame30__ms}))));
            this.fire_limit_ms = 5/*frame30*/ * ms__frame30;
        }
        this.move(dt_ms);
    }
    draw(screen) {
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta-Math.PI/2);

        this.draw_ship(screen, this.game.input.thrust);
    }

    draw_ship(screen, thrust) {
        screen.save();
        // This scale & translate needs to match the 'map' in ship_poly.
        // We could hardcode the transform into constants here but then they wouldn't match the ones in ship_poly.
        screen.translate(0,-8);
        screen.scale(.5,.5);
        if (thrust) {
            screen.beginPath();
            screen.moveTo(-5,0);

            screen.lineTo(-6 + random(-1,1), random(-16, -6));
            screen.lineTo( 0 + random(-1,1), random(-16, -6));
            screen.lineTo(+6 + random(-1,1), random(-16, -6));

            screen.lineTo(5,0);
            screen.closePath();
            screen.strokeStyle = "orange";
            screen.lineWidth = 2;
            screen.stroke();
        }
        screen.restore();

        this.fill_poly(screen, this.ship_poly, this.ship_fill(), this.ship_stroke());
    }

    ship_stroke(alpha = 1) { return `hsla(120, 0%, 100%, ${Math.max(0, Math.min(alpha, 1))})` } // "white"
    ship_fill(alpha = 1)   { return `hsla(120, 100%, 25%, ${Math.max(0, Math.min(alpha, 1))})`} // "green"

    ship_poly = [
        [  0,  0],
        [ -8,  0],
        [-16,-10], // back leftmost point
        [  0, 40], // tip of the nose
        [ 16,-10], // back rightmost point
        [  8,  0],
    ].map(pt => [ pt[0]/2, pt[1]/2 - 8 ]);
}


class BulletActor extends MovingObjectActor {
    constructor(game, position, velocity_px__ms, collision_class, color) {
        super(velocity_px__ms, 0, Math.PI/8 * frame30__ms);
        this.game = game;
        this.name = "bullet";
        this.collision_class = collision_class || "ship and bullets";
        this.color = color || "yellow";
        this.position = position;
        this.theta = 0;
        this.life_ms = 2 * ms__sec; //60 * actual_fps__30_fps; // 2 seconds...
        this.radius = 4;
    }
    collide() {
        this.game.remove_actor(this);
        this.explode_in_flames({max_radius: 10, steps: 3, explode_time_ms: 100, hold_time_ms: -50, fade_time_ms: 100, lineWidth: [2, .3]}); // Very small flames (for bullet on bullet violence)
    }
    think(dt_ms) {
        if ((this.life_ms -= dt_ms) <= 0)
            this.game.remove_actor(this);
        this.move(dt_ms);
    }

    draw(screen) {
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta);

        screen.fillStyle = this.color;
        screen.fillRect(-2,-2,4,4);
    }
}
class AsteroidActor extends MovingObjectActor {
    constructor(game, position, velocity, spin, size) {
        super(velocity,0,spin);
        this.game = game;
        this.name = "asteroid";
        this.collision_class = "asteroids";
        this.position = position;
        this.theta = 0;
        this.size = size;
        let r = [0, 13, 33, 45][size];
        let asteroid = this.random_jagged_circle(14, 70, r/2, r);
        this.outline = asteroid.polygon;
        this.radius = asteroid.radius;
    }

    collide(other) {
        this.game.game.score(25*this.size);
        if (this.size > 1)
            for (var i=0; i<2; i++)
                this.game.actors.push(new AsteroidActor(this.game,
                                                        this.position,
                                                        point_sum(point_sum(this.velocity_px__ms, point_scale(other.radius / this.radius, other.velocity_px__ms)),
                                                                  polar_to_cartesian({theta:random(0, Math.PI*2),
                                                                                      r:random(.5,2) * frame30__ms})),
                                                        random(-Math.PI/20, +Math.PI/20) * frame30__ms,
                                                        this.size -1));

        this.game.remove_actor(this);
        var debris = this.random_jagged_circle(5, 15, 2.5, 5.5);
        this.explode((screen, life_percent) => {
            this.fill_poly(screen, debris.polygon,
                           sprintf("rgba(%d,%d,%d,%f)", 20,20,20,  Math.min(1, life_percent*3)),
                           sprintf("rgba(%d,%d,%d,%f)", 255,255,0, Math.min(1, life_percent*3))
                          );
        });
    }
    think (dt_ms) {
        this.move(dt_ms);
    }
    draw(screen) {
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta-Math.PI/2);

        this.fill_poly(screen, this.outline, "rgb(20,20,20)", "brown");
    }
}

class UFOActor extends MovingObjectActor {
    constructor(game, small) {
        super(0, 0, 0);
        this.game = game;
        this.name = "ufo";
        this.collision_class = "ufo";
        this.position = {x: 0, y: random(0, this.game.div.canvas.height)};
        this.speed = random(5, 10)/60;
        this.radius = small ? 10 : 20;
        this.theta = -90 * Math.PI/180;
        this.small = small;
        this.light_offset = 0;
        this.change_direction();
        this.fire();
    }

    change_direction() {
        this.move_straight_life_ms = random(500, 1000);
        this.velocity_px__ms = polar_to_cartesian({r: this.speed,
                                                   theta: this.velocity_px__ms.y >= 0 ? -1 : 1 * random(1/16*Math.PI, 3/16*Math.PI)});
    }

    fire() {
        if (this.hold_fire_ms != undefined) { // don't shoot immediately.
            let theta = random(0, 2*Math.PI);
            this.game.actors.push(new BulletActor(this.game,
                                                  point_sum(this.position,
                                                            polar_to_cartesian({ theta:theta,
                                                                                 r: this.radius})),
                                                  point_sum(this.velocity_px__ms,
                                                            polar_to_cartesian({ theta:theta,
                                                                                 r: 5/*px__frame30*/ * frame30__ms})),
                                                  "ufo", "red"));
        }
        this.hold_fire_ms = random(500, 1000);
    }

    collide(other) {
        this.game.game.score(this.small ? 350 : 200);
        this.game.remove_actor(this);

        // Whatever hit us moves us
        this.mass = this.radius ** 2;
        let other_mass = other.radius**2;
        let other_velocity = other.velocity_px__ms;
        let other_position = other.position;
        return () => {
            this.newtonian_collision(other_position, other_velocity, other_mass);
            this.break_apart([this.saucer_poly, this.cockpit_poly],
                             (screen, life_percent) => {
                                 screen.scale(...this.small ? [.5,.5] : [1,1]);
                                 screen.strokeStyle = this.ufo_stroke(life_percent*3);
                                 screen.fillStyle = this.saucer_fill(life_percent*3);
                             });
            this.explode_in_flames({velocity_px__ms: this.velocity_px__ms, max_radius: this.radius*3});
        }
    }

    think(dt_ms) {
        if ((this.move_straight_life_ms -= dt_ms) <= 0)
            this.change_direction();

        if ((this.hold_fire_ms -= dt_ms) <= 0)
            this.fire();

        this.move_nowrap(dt_ms);
        if (this.position.x > this.game.div.canvas.width) // Go away once we've made our way across the screen
            this.game.remove_actor(this);
        this.wrap(); // handle y wrap

        this.light_offset -= dt_ms/250; // Animate the lights on the side of the saucer
        if (this.light_offset < 0)
            this.light_offset += -Math.ceil(this.light_offset)+1;
    }

    draw(screen) {
        screen.save();
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta-Math.PI/2);
        screen.scale(...this.small ? [.5,.5] : [1,1]);
        this.draw_ufo(screen, this.light_offset);
        screen.restore();
    }

    draw_ufo(screen, light_offset) {
        screen.save();
        this.fill_poly(screen, this.saucer_poly, this.saucer_fill(), this.ufo_stroke());
        this.fill_poly(screen, this.cockpit_poly, this.cockpit_fill(), this.ufo_stroke());
        screen.fillStyle = "white";
        let lights = 7;
        let light_len = 38;
        let light_delta = light_len/(lights);
        screen.translate(-light_len/2+.5, -7+.5);
        for (let i=0; i<lights; i++) {
            let x = (i+light_offset)*light_delta;
            // alpha_ramp's math is hard for me to follow. Here are the ranges of each term:
            // x                        -> 0 .. L
            // x-L/2                    -> -L/2 .. L/2
            // abs(x-L/2)               -> L/2 .. 0 .. L/2
            // L/2-abs(x-L/2)           -> 0 .. L/2 .. 0
            // (L/2-abs(x-L/2))/(D*2.5) -> 0 .. 1 .. M .. 1 .. 0  (1 @ x == D*2.5, x == L-D*2.5) M==some arbitrary max
            let alpha_ramp = (light_len/2 - Math.abs(x-light_len/2))/(light_delta*2.5);

            this.fill_rect(screen, x, 0, 2, 2,
                           sprintf("rgba(255,255,255,%d%%)", Math.min(100, 20 + 80*alpha_ramp)),
                           undefined);
        }
        screen.restore();
    }

    saucer_poly = [[-12,  0],
                   [-20, -7], // left hip
                   [-12,-14],
                   [ 12,-14],
                   [ 20, -7], // right hip
                   [ 12,  0]];

    cockpit_poly = [[-12,  0],
                    [-12,  9],
                    [ -6, 16], // cabin top
                    [  6, 16],
                    [ 12,  9],
                    [ 12,  0]];

    ufo_stroke(alpha = 1)   { return `hsla(180, 100%, 50%, ${Math.max(0, Math.min(alpha, 1))})` } // "cyan"
    saucer_fill(alpha = 1)  { return `hsla(180, 10%, 10%, ${Math.max(0, Math.min(alpha, 1))})`}   // dark grey
    cockpit_fill(alpha = 1) { return `hsla(180, 10%, 4%, ${Math.max(0, Math.min(alpha, 1))})`}    // even darker grey
}

class DebrisActor extends MovingObjectActor {
    constructor(game, position, velocity_px__ms, life_ms, options, drawer) {
        super(velocity_px__ms, options.friction || 0, random(-Math.PI/8, +Math.PI/8) * frame30__ms);
        this.game = game;
        this.name = "debris";
        this.drawer = drawer;
        this.position = position;
        this.theta = 0;
        this.max_life_ms = this.life_ms = life_ms;
        this.trail_length = 5;
        Object.assign(this, options);

        this.trail = [];
    }
    think(dt_ms) {
        if ((this.life_ms -= dt_ms) <= 0)
            this.game.remove_actor(this);
        this.trail.push(this.position);
        if (this.trail.length > this.trail_length)
            this.trail.shift();
        this.move(dt_ms);
    }

    draw(screen) {
        for (var t in this.trail) {
            screen.fillStyle = sprintf("rgba(%d,%d,%d,%f)", 255,128,0, t/(this.trail_length/2) * (this.life_ms/this.max_life_ms));
            screen.fillRect(this.trail[t].x, this.trail[t].y, t*.5+2, t*.5+2);
        }
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta - Math.PI/2);

        this.drawer(screen, this.life_ms/this.max_life_ms);
    }
}

class ExplodeInFlamesActor extends MovingObjectActor {
    constructor(game, position, options) {
        super(0, 0, 0);
        this.game = game;
        this.position = position;
        this.theta = 0;

        this.explode_time_ms = 1000;
        this.hold_time_ms = -500;
        this.fade_time_ms = 1000;
        this.again_again = undefined;

        this.max_radius = 150;
        this.steps = 10;
        this.linewidth = [5, .2];

        Object.assign(this, options);
        this.options = options;

        if (this.position_offset)
            this.position = point_sum(this.position, this.position_offset);

        this.step_scale = this.max_radius / this.steps;
        this.life_ms = 0;
        this.max_life_ms = this.explode_time_ms + this.hold_time_ms + this.fade_time_ms;
        this.flame_poly = this.random_jagged_circle(15, 25, .5, 1).polygon;
    }

    think(dt_ms) {
        this.move(dt_ms);
        this.life_ms += dt_ms;

        if (this.again_again && this.life_ms > this.again_again.after_ms) {
            this.game.actors.push(new ExplodeInFlamesActor(this.game, this.position,
                                                           Object.assign({}, this.options, { again_again: undefined }, this.again_again.options)));
            delete this.again_again;
        }

        if (this.life_ms > this.max_life_ms)
            this.game.remove_actor(this);
    }

    draw(screen) {
        screen.translate(this.position.x, this.position.y);
        screen.rotate(this.theta - Math.PI/2);
        let expl_progress = Math.min(1, this.life_ms/this.explode_time_ms);
        let fade_progress = Math.max(0, this.life_ms - this.explode_time_ms - this.hold_time_ms)/this.fade_time_ms;
        for (let step=Math.floor(this.steps * fade_progress);
             step < this.steps * expl_progress;
             step++) {
            screen.save();

            let scale = ramp(this.step_scale/2, this.step_scale, this.max_life_ms, this.life_ms);
            screen.scale(scale * step, scale * step);
            screen.strokeStyle = `hsla(${ramp(0, 60, this.steps, step)}, 100%, ${ramp(80, 40, 2000, this.life_ms + step * 200)}%, ${ramp(1, 0, 1, fade_progress)})`;
            screen.lineWidth = ramp(this.linewidth[0], this.linewidth[1], this.steps, step)/(this.step_scale*step);
            screen.beginPath();
            for (let p of this.flame_poly)
                screen.lineTo(p[0], p[1]);
            screen.closePath();
            screen.stroke();

            screen.restore();
        }
    }
}

function ramp(from, to, total, cur) {
    return from + Math.max(0, Math.min(cur, total))*(to-from)/total;
}

class FPSActor {
    constructor(game) {
        this.game = game;
        this.name = "fps";

        this.frame_times = [];
    }

    think(dt_ms) {
        this.pause_think(dt_ms)
    }
    pause_think(dt_ms) {
        this.frame_times.push(dt_ms);
        if (this.frame_times.length > 60) this.frame_times.shift();
        this.fps = 1000 / (this.frame_times.reduce((sum, t) => sum + t) / this.frame_times.length);
    }

    draw(screen) {
        screen.save();
        screen.translate(this.game.div.canvas.width-10,10);
        screen.scale(5,10);
        screen.lineWidth = 1/5;
        screen.strokeStyle = '#888';
        draw_string(screen, sprintf("%d FPS", this.fps), {justify:'right'});
        screen.restore();
    }
}

class HighScoreActor {
    constructor(game) {
        this.game = game;
        this.score_buffer = this.game.highscore;
        this.life_ms = 0;
        this.scroll_in_life_ms = 0;
        this.timeframes = Object.keys(this.score_buffer.timeframe);
        this.timeframei = this.timeframes.findIndex(t => t == this.score_buffer.current_timeframe);
    }

    ready() {
        return !this.score_buffer.state.loading;
    }

    added() {
        this.scroll_in_life_ms = 0;
    }

    timeframe_step(step) {
        this.timeframei = (this.timeframei + step + this.timeframes.length /*keep it positive*/) % this.timeframes.length;
        this.score_buffer.switch_timeframe(this.timeframes[this.timeframei]);
    }

    think(dt_ms) {
        this.pause_think(dt_ms);
    }

    pause_think(dt_ms) {
        this.life_ms += dt_ms;

        if (this.game.input.next) {
            delete this.game.input.next;
            this.timeframe_step(+1);
        }
        if (this.game.input.previous) {
            delete this.game.input.previous;
            this.timeframe_step(-1);
        }
        if (this.score_buffer.state.loading)
            this.scroll_in_life_ms = 0; // so it always starts scrolling when it appears
        else
            this.scroll_in_life_ms += dt_ms;
    }

    draw(screen) {
        screen.save();
        try {
            screen.translate(this.game.div.canvas.width/2, 0);
            screen.strokeStyle = "white";
            let font_size = (px) => {
                screen.scale(1,2);
                let scale = this.game.div.canvas.height / px;
                screen.scale(px/2,px/2);
                screen.lineWidth = 1/(px/2);
            };
            let posessive = (timeframe) => timeframe == "All Time" ? timeframe : timeframe + "'s";
            screen.translate(0, 200);
            screen.save();
            font_size(30);
            draw_string(screen, ['span', { className: "jumpy" }, sprintf("←Q   %s High Scores   E→", posessive(this.score_buffer.state.timeframe)) ],
                        { justify:'center',
                          classes: {jumpy: { _jumpy:(i) => {
                              screen.translate(0, Math.sin(i*2*Math.PI/10 + this.life_ms*2*Math.PI/1000) / 4);
                          } } } });
            screen.restore();
            screen.translate(0, 40*1.5);
            font_size(20);
            let header;
            draw_string(screen, header=sprintf("%2s %-20.20s %6s %5s\n", "", "Name", "Score", "Time"), { justify:'center' });
            let chars = header.length;
            screen.translate(0, 1.2 + .2);

            screen.beginPath();
            screen.moveTo(-chars*1.5/2, 0);
            screen.lineTo( chars*1.5/2, 0);
            screen.stroke();

            screen.translate(0, .2 + .2);

            if (this.score_buffer.state.loading) {
                draw_string(screen, "Loading Scores…", { justify:'center' });
            } else if (this.score_buffer.state.error) {
                screen.strokeStyle = 'hsl(0, 100%, 30%)';
                draw_string(screen, `Err: ${this.score_buffer.state.error}`, { justify:'center' });
            } else {
                let place = 1;
                let score_text = ['span',
                                  this.score_buffer.state.scores.map((s,i) =>
                                      ['span',
                                       { classes: [].concat(s.user == Login.user ? [ 'myscore' ] : [],
                                                            (s.play_id == this.score_buffer.play_id) ? ['lastscore'] : []) },
                                       sprintf("%2s %-20.20s %6d ",
                                               i>0 && this.score_buffer.state.scores[i-1].score == s.score ? '' : place++,
                                               !s.banned || s.user == Login.user ? s.user : censor("".normalize ? s.user.normalize("NFD") : s.user),
                                               s.score),
                                       elapsed_digital(s.elapsed),
                                       "\n"])];

                draw_string(screen, score_text, { justify: 'center',
                                                  spacing: 1.4,
                                                  classes: { lastscore: { strokeStyle: (i) => hsl(ramp(0,360, chars, (-i + chars*this.life_ms/2500) % chars), 100, 50),
                                                                          _h_scroll_in: (i) => screen.translate(80 * Math.cos(Math.min(Math.PI/2, -i/50+this.scroll_in_life_ms*2*Math.PI/5000)), 0),
                                                                          _hop: (i) => screen.translate(0, -Math.max(0, Math.sin(-i*2*Math.PI/(chars*3) + this.life_ms*2*Math.PI/3000)*chars*3-(chars*3-1)) / 4),
                                                                        },
                                                             myscore: { lineWidth: 2/12,
                                                                        strokeStyle: (i,r,c) => hsl(ramp(0,360, chars, (-i-r + chars*this.life_ms/5000) % chars), 80, 70),
                                                                      },
                                                             zeros: { globalAlpha: .2}} });
            }
        } catch(e) { printf("Caught error: %s\n", e); }
        screen.restore();
    }
}

class HighScoreIntervalViewerBuffered extends HighScoreIntervalViewer {
    constructor(title) {
        super(title);
        this.state = { loading: false, scores: [], game_id: undefined, error: undefined };
        this.init();
    }

    update_timeframe_tabs(new_t) {
        this.state.timeframe = new_t;
    }

    loading() {
        this.state.error = undefined;
        this.state.scores = undefined;
        this.state.loading = true;
    }

    render(scores) {
        this.state.loading = false;
        this.state.scores = scores;
    }

    error(error) {
        this.state.loading = false;
        this.state.error = error;
    }
}


function clamp(v,min,max) { return Math.max(min, Math.min(v, max)) }
function hsl(hue, saturation, lightness, alpha=undefined) { return alpha == undefined ? sprintf("hsl(%d, %d%%, %d%%)", clamp(hue, 0, 360), clamp(saturation, 0,100), clamp(lightness, 0, 100))
                                                                                      : sprintf("hsla(%d, %d%%, %d%%, %.3f)", clamp(hue, 0, 360), clamp(saturation, 0, 100), clamp(lightness, 0, 100), clamp(alpha, 0, 1)); }

const r = String.raw;
var alpha_font =  [r` _   _   _  _   __  _  __     _ _  _ _                  _   _   _   _   __ _ _                        __ `,
                   r`/_\ |_> |  | \ |_  |_ | _ |_|  |    |  |/ |  |\/| |\ | | | |_| | | |_| |_   |  | | |  | |    | \/ \ /  / `,
                   r`| | |_> |_ |_/ |__ |  |_| | | _|_ |_|  |\ |_ |  | | \| |_| |   |_x | \ __|  |  |_|  \/   \/\/  /\  |  /_ `,
                   r`a   b   c  d   e   f  g   h   i   j    k  l  m    n    o   p   q   r   s   t   u   v    w      x  y   z  `];
var num_font = [r` _      __  __       __  __ ___  _   _  `,
                r`| | /|   _| __| |_| |_  |_    / |_| |_| `,
                r`|_| _|_ |__ __|   | __| |_|  |  |_|   | `,
                r`0   1   2   3   4   5   6   7   8   9   `];
var symbol_font = [r`                                                      `,
                   r`  -                                     _ _ \|/ /_ _\ `,
                   r`  -           _ _           _   _   _   /|\     \   / `,
                   r`:             _ .           …           *   *   ←  →  `];

var big_glyphs = [r` __  __                           ____  `,
                  r`/  \/  \              _/         /    \ `,
                  r`\      /                              | `,
                  r` \    /                              /  `,
                  r`  \  /                              |   `,
                  r`   \/     _/                        _   `,
                  r`♥        ,           '           ?      `];

function build_font(font) {
    let height = font.length-1;
    let maxy = height-1;
    var start = font[height].split(/[^ ]/);
    start.shift();
      var i=0;
    var char_slice = function(font, start, length) {
        return font.slice(0,height).map(line => line.slice(start, start+length));
    };
    let debug = new DebugFont(start.length);
    var lines = {};
    for (var s in start) {
        var l = start[s].length;
        var c = char_slice(font, i+0, l);
        var ch = font[height].charAt(i);
        let get = (x,y) => x < 0 || y < 0 || y > maxy ? undefined : c[y].charAt(x);
        lines[ch] ||= [];
        var xscale = 1/l;
        let yscale = 1/maxy;
        for (var y=0; y<height; y++)
            for (var x=0; x<l; x++) {
                let yy=y;
                let pipex = (x) => x + (x == 0 ? 0 : x == l-1 ? 1 : .5);
                switch (get(x,y)) {
                case '-': yy -= .5;
                case '_': {
                    let x1 = x, x2 = x+1;
                    if (get(x+1,y+1) == '|' ||
                        get(x+1,y)   == '|' ||
                        get(x+1,y)   == '\\') x2 = pipex(x+1); // →
                    if (get(x-1,y)   == '|' ||                // practically everything
                        get(x-1,y+1) == '|' ||                // B,C,D,E,F,G,I,J,O,P,Q,R,S,T,Z
                        get(x-1,y)   == '/') x1 = pipex(x-1); // Z
                    lines[ch].push({from:[x1*xscale, yy*yscale], to:[x2*xscale, yy*yscale]});
                }   break;
                case '|': {
                    let xx = pipex(x);
                    lines[ch].push({from:[(xx)*xscale, (y-1) * yscale], to:[(xx)*xscale, (y)*yscale]});
                }   break;
                case '/': {
                    let x1 = x, x2 = x+1;
                    if (get(x-1,y+1) == '|' ||                // Y,K
                        get(x-1,y)   == '|') x1 = pipex(x-1); // *
                    if (get(x+1,y-1) == '|' ||                // W,V
                        get(x+1,y)   == '|') x2 = pipex(x+1); // M
                    lines[ch].push({from:[x1*xscale, y*yscale], to:[x2*xscale, (y-1)*yscale]});
                }   break;
                case '\\': {
                    let x1 = x, x2 = x+1;
                    if (get(x-1,y-1) == '|' ||                // W,V
                        get(x-1,y)   == '|') x1 = pipex(x-1); // M,N
                    if (get(x+1,y+1) == '|' ||                // Y,K
                        get(x+1,y)   == '|') x2 = pipex(x+1); // N
                    lines[ch].push({from:[x1*xscale, (y-1)*yscale], to:[x2*xscale, y*yscale]});
                }   break;
                case '>': {                                   // B
                    let x1 = x, x2 = x+1;
                    let yt = y-1, ym = y-.5, yb = y;
                    lines[ch].push({from:[x1*xscale, yt*yscale], to:[x2*xscale, ym*yscale]});
                    lines[ch].push({from:[x2*xscale, ym*yscale], to:[x1*xscale, yb*yscale]});
                }   break;
                case 'x': {                                   // Q
                    let x1 = x, x2 = x+1;
                    let yt = y-1, yb = y;
                    lines[ch].push({from:[x1*xscale, yb*yscale], to:[x2*xscale, yt*yscale]});
                    lines[ch].push({from:[x1*xscale, yt*yscale], to:[x2*xscale, yb*yscale]}); // Q's tail
                }   break;
                }
            }

        debug.draw_char(0+s, ch, l, maxy, lines[ch]);

        i += l+1;
    }
    return lines;
}

class DebugFont {
    constructor(chars) {
        return undefined;
        let padding = .1;
        let c_w = Math.min(10, chars);
        let c_h = Math.ceil(chars / c_w);
        let size = { width: c_w, height:c_h };
        let zoom = 1000/c_w;
        let el = doc(["canvas", { style: { width: `${size.width*zoom}px`, height: `${size.height*zoom}px`} }]);
        el.width = size.width*zoom;
        el.height = size.height*zoom;
        print(doc(['span', el, ['br']]));
        let ctx = el.getContext("2d");
        ctx.fillStyle = "black";
        ctx.fillRect(0,0, el.width, el.height);
        ctx.scale(zoom, zoom);
        ctx.scale(c_w/(c_w+(c_w-1)*padding), c_h/(c_h+(c_h-1)*padding));
        ctx.translate(size.width/2, size.height/2);
        ctx.scale(.93, .93);
        ctx.translate(-size.width/2, -size.height/2);
        ctx.lineWidth = 2/zoom;
        Object.assign(this, { el: el, ctx: ctx, size:size, zoom:zoom, padding:padding });
    }

    draw_grid(ch, l, maxy) {
        let {ctx} = this;
        ctx.strokeStyle = "rgb(20,20,20)";
        for (let y=0; y<=maxy; y++) {
            ctx.beginPath();
            ctx.moveTo(0,y/maxy);
            ctx.lineTo(1,y/maxy);
            ctx.stroke();
        }
        ctx.strokeStyle = "rgb(20,20,20)";
        for (var x=0; x<=l; x++) {
            ctx.beginPath();
            ctx.moveTo(x/(l),0);
            ctx.lineTo(x/(l),1);
            ctx.stroke()
        }
        ctx.strokeStyle = "rgb(40,40,40)";
        ctx.beginPath();
        ctx.moveTo(0,0);
        ctx.lineTo(1,0);
        ctx.lineTo(1,1);
        ctx.lineTo(0,1);
        ctx.closePath();
        ctx.stroke();

        ctx.fillStyle = "rgb(150,150,150)";
        ctx.fillRect(0,0,.25,.25);
        ctx.font = `.25px serif`;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillStyle = "black";
        ctx.fillText(ch, .25/2, .25/2+.07);
    }

    draw_char(s, ch, l, maxy, lines) {
        let {ctx, size, padding} = this;
        if (!ctx) return; // debugging not enabled
        ctx.save();
        let cy = Math.floor(s/size.width);
        let cx = s % size.width;
        ctx.translate(cx + (cx)*padding, cy + (cy) * padding);

        this.draw_grid(ch, l, maxy);

        ctx.strokeStyle = "#9ff";
        for (let line of lines) {
            ctx.beginPath();
            ctx.moveTo(line.from[0], line.from[1]);
            ctx.lineTo(line.to[0], line.to[1]);
            ctx.fillStyle = "pink";
            let pt_w=1/30, pt_h=1/30;
            ctx.fillRect(line.from[0] - pt_w/2, line.from[1] - pt_h/2, pt_w, pt_h);
            ctx.fillRect(line.to[0] - pt_w/2, line.to[1] -pt_h/2, pt_w, pt_h);
            ctx.stroke();
        }
        ctx.restore();
    }
}


var font;
on_load(function() {
    font = merge(build_font(alpha_font),
                 build_font(num_font),
                 build_font(symbol_font),
                 build_font(big_glyphs));
    font[' '] = []; // Special case space since my split wont find it. :-(
    font['\u00a0'] = []; // nbsp
});


// The idea here is that it returns an array of lines, just like the old draw_string had after it called
// split("\n") on the input. Along with that it returns a sparsely populated 2 dimensional hash where the
// [row][col] entries are a list of style directives to apply before drawing the character at that location.
//
// Each style directive is either a set of attributes to merge into the current style, or the string "pop" to
// go back to the old style (like an html </span> close tag). This code doesn't care about the specifics of
// the styles, except it separates classes from "inline" styles since it was easier to do here.
function richtext_to_lines(text) {
    class node {
        constructor(s, text) {
            this.lines = s.split("\n");
            this.my_style = { inline: {}, classes: undefined };
            this.styles = {};
            this.push_styles_at({row:0,col:0}, [this.my_style]);
        }
        end_pos() {
            let row = this.lines.length-1;
            let col = this.lines[row].length;
            return { row:row, col:col };
        }
        push_styles_at(pos, styles) {
            this.styles[pos.row] ||= {};
            this.styles[pos.row][pos.col] ||= [];
            this.styles[pos.row][pos.col].push(...styles);
        }
        append_lines(new_lines) {
            this.lines[this.end_pos().row] += new_lines.shift();
            this.lines = this.lines.concat(new_lines);
        }
        setAttribute(k,v) { if (k == "classes") this.my_style.classes = v;
                            else if (k == "className") this.my_style.classes = [v];
                            else this.my_style.inline[k] = v; }
        appendChild(child)  {
            let { row, col } = this.end_pos();
            let new_lines = child.lines;
            if (new_lines.length > 1 && new_lines[0] == "" && this.styles[row]) {     // Annoying special case. If the first new char is '\n' then
                this.push_styles_at({row:row+1, col:0}, this.styles[row][col] || []); // everything we had on the last line pointing a the "next"
                delete this.styles[row][col];                                         // character needs to move down first.
            }
            for (let [r, cols] of Object.entries(child.styles)) {
                for (let [c, styles] of Object.entries(cols)) {
                    let extra_col = r == 0 ? col : 0;
                    this.push_styles_at({row: Number(r)+row, col: Number(c)+extra_col}, styles);
                }
            }
            this.append_lines(new_lines);
            this.push_styles_at(this.end_pos(), ["pop"]);
        }
    }
    let asteroids_doc = {
        createElement: (_tag_name) => new node("", false),
        createTextNode: (s) => new node(s, true),
    };

    let out = doc(text, asteroids_doc);
    return { line: out.lines, styles: out.styles || {} };
}

function draw_string(screen, s, options={}) {
    screen.save();

    let class_def = options.classes || {};
    let { line, styles } = richtext_to_lines(s);

    var kerning = options.kerning || 1.5;
    var spacing = options.spacing || 1.2;

    if (options.vcenter)
        screen.translate(0, -line.length * spacing / 2);

    let style_stack = []; // We call this a stack but we use .shift() and .unshift() because style_stack[0] is easier than style_stack[style_stack.length-1]
    for (var li in line) {
        screen.save();
        if (options.justify == 'center')
            screen.translate(-line[li].length * kerning / 2, 0);
        if (options.justify == 'right')
            screen.translate(-line[li].length * kerning, 0);
        for (var si=0; si<line[li].length; si++) {
            var f = font[line[li].charAt(si).toLowerCase()] || font['?'];
            if (!f) {
                printf("No character for '%s' _or_ the backup character '?' [%#x]!\n", line[li].charAt(si), line[li].charCodeAt(si));
                continue;
            }
            if (styles[li] && styles[li][si]) {
                for (let s of styles[li][si])
                    if (s == "pop")
                        style_stack.shift();
                    else
                        style_stack.unshift(Object.fromEntries(
                            Object.entries(Object.assign({}, class_def.default||{}, style_stack[0]||{}, ...(s.classes||[]).map(c => class_def[c]), s.inline))
                                .map(([k, v], i) => [k, typeof(v) == 'function' ? {f:v, i:0} : v])));
            }
            screen.save(); // we save here so that we don't have to know the "default" versions of any styles we are about to set
            for (let [k,v] of Object.entries(style_stack[0]))
                if (typeof(v.f) == "function") screen[k] = v.f(v.i++, li-0, si);
                else screen[k] = v;
            for (var l = 0; l<f.length; l++) {
                screen.beginPath();
                screen.moveTo(f[l].from[0], f[l].from[1]);
                screen.lineTo(f[l].to  [0], f[l].to  [1]);
                screen.closePath();
                screen.stroke();
            }
            screen.restore();
            screen.translate(kerning, 0);
        }
        screen.restore();
        screen.translate(0,spacing);
    }
    screen.restore();
}

var the_game;
on_load(function() {
    window.the_game = the_game = new Asteroids(doc.id("playfield"),
                                               doc.id("global_high_score"),
                                               doc.id("scoretab"));
    the_game.new_game();

    doc.id("keybinding-toggle").onclick = (event) => {
        doc.id('keys').classList.toggle("hidden");
        return false;
    }
});

function rand_unit() {
    return rand() / 0x7fffffff;
}

function random(low, high) {
    return rand_unit() * (high - low) + low;
}

